//#region src/i18n/de.ts
const de = {
	shared: {
		versionSuffix: ({ version }) => ` Version: ${version}.`,
		contactLabels: {
			legalName: () => "Firmenname:",
			address: () => "Anschrift:",
			email: () => "E-Mail:",
			phone: () => "Telefon:",
			dpo: () => "Datenschutzbeauftragter:"
		},
		legalBasisLabels: {
			consent: () => "Einwilligung (Artikel 6 Absatz 1 Buchstabe a DSGVO)",
			contract: () => "Erfüllung eines Vertrags (Artikel 6 Absatz 1 Buchstabe b DSGVO)",
			legal_obligation: () => "Erfüllung einer rechtlichen Verpflichtung (Artikel 6 Absatz 1 Buchstabe c DSGVO)",
			vital_interests: () => "Schutz lebenswichtiger Interessen (Artikel 6 Absatz 1 Buchstabe d DSGVO)",
			public_task: () => "Wahrnehmung einer Aufgabe im öffentlichen Interesse (Artikel 6 Absatz 1 Buchstabe e DSGVO)",
			legitimate_interests: () => "Berechtigte Interessen (Artikel 6 Absatz 1 Buchstabe f DSGVO)"
		}
	},
	privacy: {
		introduction: {
			heading: () => "Einleitung",
			body: ({ companyName, effectiveDate, versionSuffix }) => `Diese Datenschutzerklärung beschreibt, wie ${companyName} („wir", „uns" oder „unser") Informationen über Sie erhebt, verwendet und weitergibt, wenn Sie unsere Dienste nutzen. Datum des Inkrafttretens: ${effectiveDate}.${versionSuffix}`,
			contactLine: ({ contactEmail }) => `Wenn Sie Fragen zu dieser Erklärung haben, wenden Sie sich bitte an ${contactEmail}.`
		},
		childrenPrivacy: {
			heading: () => "Datenschutz für Kinder",
			body: ({ underAge }) => `Unsere Dienste richten sich nicht an Kinder unter ${underAge} Jahren. Wir erheben wissentlich keine personenbezogenen Daten von Kindern unter ${underAge} Jahren. Wenn Sie glauben, dass wir Informationen von einem Kind erhoben haben, kontaktieren Sie uns bitte umgehend.`,
			noticeLinkPrefix: () => "Weitere Informationen finden Sie in unserem ",
			noticeLinkText: () => "Datenschutzhinweis für Kinder"
		},
		dataCollected: {
			heading: () => "Welche Daten wir erheben",
			intro: {
				withGdpr: () => "Wir erheben die folgenden Kategorien personenbezogener Daten zu den unten beschriebenen Zwecken. Gemäß Artikel 6 DSGVO stützen wir uns für jeden Verarbeitungszweck auf die angegebenen Rechtsgrundlagen:",
				withoutGdpr: () => "Wir erheben die folgenden Kategorien personenbezogener Daten zu den unten beschriebenen Zwecken:"
			},
			headers: {
				withGdpr: () => [
					"Kategorie",
					"Erhobene Felder",
					"Zweck",
					"Rechtsgrundlage"
				],
				withoutGdpr: () => [
					"Kategorie",
					"Erhobene Felder",
					"Zweck"
				]
			}
		},
		consentWithdrawal: {
			heading: () => "Recht auf Widerruf der Einwilligung",
			body: ({ contactEmail }) => `Soweit wir uns für die Verarbeitung Ihrer personenbezogenen Daten auf Ihre Einwilligung stützen, haben Sie das Recht, diese Einwilligung jederzeit zu widerrufen, indem Sie uns unter ${contactEmail} kontaktieren. Der Widerruf Ihrer Einwilligung berührt nicht die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung. Soweit die Einwilligung für die Bereitstellung einer bestimmten Funktion oder Dienstleistung erforderlich ist, kann ihr Widerruf bedeuten, dass wir Ihnen diese Funktion oder Dienstleistung nicht mehr anbieten können.`
		},
		automatedDecisionMaking: {
			heading: () => "Automatisierte Entscheidungsfindung und Profiling",
			empty: () => "Wir führen keine automatisierte Entscheidungsfindung oder Profiling durch, die Ihnen gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt im Sinne von Artikel 22 DSGVO.",
			intro: () => "Wir setzen die folgenden automatisierten Verarbeitungen ein, die Ihnen gegenüber rechtliche Wirkung entfalten oder Sie in ähnlicher Weise erheblich beeinträchtigen können. Für jede beschreiben wir die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen:",
			significanceLabel: () => "Tragweite:",
			humanReview: {
				label: () => "Recht auf menschliche Überprüfung.",
				body: ({ contactEmail }) => ` Sie haben das Recht, nicht einer ausschließlich auf automatisierter Verarbeitung – einschließlich Profiling – beruhenden Entscheidung unterworfen zu werden. Um menschliches Eingreifen zu verlangen, Ihren Standpunkt darzulegen oder eine Entscheidung anzufechten, kontaktieren Sie uns unter ${contactEmail}.`
			}
		},
		dataRetention: {
			heading: () => "Aufbewahrungsdauer",
			intro: () => "Wir bewahren Ihre Daten für die folgenden Zeiträume auf:",
			headers: () => ["Kategorie", "Aufbewahrungsdauer"]
		},
		provisionRequirement: {
			heading: () => "Verpflichtung zur Bereitstellung der Daten",
			body: () => "Für jede Kategorie personenbezogener Daten, die wir erheben, geben wir nachfolgend an, ob Sie zu ihrer Bereitstellung verpflichtet sind – kraft Gesetzes, im Rahmen unseres Vertrags mit Ihnen oder als Voraussetzung für einen Vertragsabschluss – oder ob die Bereitstellung freiwillig ist, sowie die Folgen einer Nichtbereitstellung.",
			headers: () => [
				"Kategorie",
				"Charakter",
				"Folgen"
			]
		},
		cookies: {
			heading: () => "Cookies und Tracking",
			empty: () => "Wir verwenden keine Cookies oder vergleichbaren Tracking-Technologien.",
			intro: () => "Wir verwenden die folgenden Arten von Cookies und Tracking-Technologien:",
			headers: () => ["Kategorie", "Rechtsgrundlage"]
		},
		thirdParties: {
			heading: () => "Drittanbieter",
			empty: () => "Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter, außer wenn dies gesetzlich vorgeschrieben ist.",
			intro: () => "Wir teilen Daten mit den folgenden Drittanbietern:",
			headers: () => [
				"Dienst",
				"Zweck",
				"Datenschutzerklärung"
			],
			linkText: () => "Anzeigen"
		},
		userRights: {
			heading: () => "Ihre Rechte",
			intro: () => "Sie haben die folgenden Rechte bezüglich Ihrer personenbezogenen Daten:",
			labels: {
				access: () => "Recht auf Auskunft über Ihre personenbezogenen Daten",
				rectification: () => "Recht auf Berichtigung unrichtiger Daten",
				erasure: () => "Recht auf Löschung Ihrer Daten",
				portability: () => "Recht auf Datenübertragbarkeit",
				restriction: () => "Recht auf Einschränkung der Verarbeitung",
				objection: () => "Recht auf Widerspruch gegen die Verarbeitung",
				opt_out_sale: () => "Recht, dem Verkauf Ihrer personenbezogenen Daten zu widersprechen",
				non_discrimination: () => "Recht auf diskriminierungsfreie Behandlung bei der Ausübung Ihrer Rechte"
			}
		},
		dpo: {
			present: { trailing: () => ". Sie können sich für alle Fragen zu dieser Erklärung oder zum Umgang mit Ihren personenbezogenen Daten direkt an unseren Datenschutzbeauftragten wenden." },
			absentRequiredFalse: ({ reason }) => `Wir haben keinen Datenschutzbeauftragten benannt. Unsere Verarbeitungstätigkeiten erreichen nicht die Schwellen nach Artikel 37 Absatz 1 DSGVO, die eine Benennung erfordern würden.${reason}`,
			absentFallback: () => "Wir haben keinen Datenschutzbeauftragten benannt. Unsere Verarbeitungstätigkeiten erreichen nicht die Schwellen nach Artikel 37 Absatz 1 DSGVO, die eine Benennung erfordern würden. Für Fragen zu dieser Erklärung oder zum Umgang mit Ihren personenbezogenen Daten verwenden Sie bitte die oben angegebenen Kontaktdaten."
		},
		euRepresentative: { body: ({ address, email }) => ({
			prefix: "Unser Vertreter in der Europäischen Union im Sinne von Artikel 27 DSGVO ist ",
			suffix: `, ${address}, ${email}.`
		}) },
		gdprSupplement: {
			heading: () => "Ergänzende Hinweise nach DSGVO",
			scope: () => "Dieser Abschnitt gilt für Personen im Europäischen Wirtschaftsraum (EWR) gemäß der Datenschutz-Grundverordnung (DSGVO).",
			dataControllerLabel: () => "Verantwortlicher: ",
			complaintBody: {
				prefix: () => "Sie haben das Recht, bei der Datenschutzaufsichtsbehörde Ihres Wohnsitzlandes, Ihres Arbeitsorts oder des Orts des mutmaßlichen Verstoßes Beschwerde einzulegen. Eine Liste der Aufsichtsbehörden im EWR finden Sie unter ",
				linkText: () => "edpb.europa.eu/about-edpb/about-edpb/members_en",
				suffix: () => "."
			},
			transferBody: {
				prefix: () => "Soweit wir Ihre personenbezogenen Daten außerhalb des EWR übermitteln, stützen wir uns auf eine oder mehrere der in Kapitel V DSGVO vorgesehenen Garantien: (a) Übermittlungen in Länder, für die die Europäische Kommission ein angemessenes Schutzniveau festgestellt hat (die aktuelle Liste ist veröffentlicht unter ",
				adequacyLinkText: () => "commission.europa.eu/.../adequacy-decisions_en",
				middle: () => "); (b) Standardvertragsklauseln (SCC), die von der Europäischen Kommission gemäß Artikel 46 Absatz 2 Buchstabe c erlassen wurden; und (c) verbindliche interne Datenschutzvorschriften (BCR), die gemäß Artikel 47 genehmigt wurden, sofern anwendbar. Weitere Informationen zu den auf eine bestimmte Übermittlung angewandten Garantien können Sie unter ",
				email: ({ contactEmail }) => `${contactEmail} anfordern.`
			}
		},
		ukGdprSupplement: {
			heading: () => "Datenschutzrechte im Vereinigten Königreich (UK-GDPR)",
			scope: () => "Dieser Abschnitt gilt für Personen im Vereinigten Königreich gemäß der UK-Datenschutz-Grundverordnung (UK-GDPR), wie sie durch den Data Protection Act 2018 angepasst wurde.",
			dataControllerLabel: () => "Verantwortlicher: ",
			ico: {
				prefix: () => "Die Datenschutzaufsichtsbehörde im Vereinigten Königreich ist das ",
				label: () => "Information Commissioner's Office (ICO)",
				suffix: () => ". Wenn Sie der Auffassung sind, dass wir Ihre Daten nicht gemäß dem britischen Datenschutzrecht behandelt haben, haben Sie das Recht, beim ICO unter ",
				linkText: () => "ico.org.uk/make-a-complaint",
				suffix2: () => " Beschwerde einzulegen."
			},
			transferBody: () => "Soweit wir Ihre personenbezogenen Daten außerhalb des Vereinigten Königreichs übermitteln, stellen wir sicher, dass angemessene Garantien im Einklang mit der UK-GDPR vorhanden sind, einschließlich des UK International Data Transfer Agreement oder des UK Addendum zu den EU-Standardvertragsklauseln, sofern anwendbar."
		},
		ccpaSupplement: {
			heading: () => "Datenschutzrechte in Kalifornien (CCPA)",
			intro: () => "Wenn Sie in Kalifornien ansässig sind, haben Sie die folgenden zusätzlichen Rechte:",
			rights: {
				know: () => "Recht auf Auskunft – Sie können die Offenlegung der personenbezogenen Informationen verlangen, die wir über Sie erheben, verwenden und weitergeben.",
				delete: () => "Recht auf Löschung – Sie können die Löschung der personenbezogenen Informationen verlangen, die wir über Sie erhoben haben.",
				optOut: () => "Widerspruchsrecht gegen den Verkauf – Sie können dem Verkauf Ihrer personenbezogenen Informationen widersprechen.",
				nonDiscrimination: () => "Recht auf Nichtdiskriminierung – Wir werden Sie für die Ausübung Ihrer CCPA-Rechte nicht diskriminieren."
			},
			submitting: {
				label: () => "Einreichung von Anträgen.",
				body: () => " Um eines dieser Rechte auszuüben, kontaktieren Sie uns über eine der unten angegebenen Methoden. Wir werden innerhalb der in CCPA §1798.130 vorgeschriebenen Fristen antworten."
			}
		},
		contact: {
			heading: () => "Kontakt",
			intro: () => "Kontaktieren Sie uns:"
		},
		provisionBasisLabels: {
			statutory: () => "Gesetzlich vorgeschrieben",
			contractual: () => "Vertraglich vorgeschrieben",
			"contract-prerequisite": () => "Voraussetzung für einen Vertragsabschluss",
			voluntary: () => "Freiwillig"
		},
		cookieCategoryLabels: {
			essential: () => "Essenzielle Cookies – erforderlich für die Funktion des Dienstes",
			analytics: () => "Analyse-Cookies – helfen uns zu verstehen, wie der Dienst genutzt wird",
			functional: () => "Funktionale Cookies – speichern Ihre Einstellungen und Präferenzen",
			marketing: () => "Marketing-Cookies – dienen der Auslieferung relevanter Werbung"
		},
		cookieCategoryFallback: ({ key }) => `${key}-Cookies`
	},
	cookie: {
		introduction: {
			heading: () => "Cookie-Richtlinie",
			body: ({ companyName, effectiveDate, versionSuffix }) => `Diese Cookie-Richtlinie erläutert, wie ${companyName} („wir", „uns" oder „unser") Cookies und vergleichbare Tracking-Technologien auf unseren Diensten verwendet. Datum des Inkrafttretens: ${effectiveDate}.${versionSuffix}`
		},
		whatAreCookies: {
			heading: () => "Was sind Cookies?",
			body1: () => "Cookies sind kleine Textdateien, die von den von Ihnen besuchten Websites auf Ihrem Gerät abgelegt werden. Sie werden weithin eingesetzt, damit Websites effizienter funktionieren und um Informationen an die Website-Betreiber bereitzustellen.",
			body2: () => "Cookies können „Sitzungs-Cookies\" sein (werden beim Schließen des Browsers gelöscht) oder „dauerhafte Cookies\" (verbleiben auf Ihrem Gerät, bis sie ablaufen oder gelöscht werden)."
		},
		types: {
			heading: () => "Arten der von uns verwendeten Cookies",
			empty: () => "Wir verwenden derzeit keine Cookies.",
			headers: () => ["Art", "Beschreibung"],
			labels: {
				essential: {
					label: () => "Essenzielle Cookies",
					description: () => "Erforderlich für die grundlegende Funktion unserer Dienste. Sie können nicht deaktiviert werden."
				},
				analytics: {
					label: () => "Analyse-Cookies",
					description: () => "Helfen uns zu verstehen, wie Besucher mit unseren Diensten interagieren, damit wir sie verbessern können."
				},
				functional: {
					label: () => "Funktionale Cookies",
					description: () => "Ermöglichen erweiterte Funktionen und Personalisierung, etwa das Speichern Ihrer Einstellungen."
				},
				marketing: {
					label: () => "Marketing-Cookies",
					description: () => "Werden eingesetzt, um Ihnen relevantere Werbung anzuzeigen, die auf Ihre Interessen abgestimmt ist."
				}
			},
			fallback: ({ key }) => ({
				label: `${key.charAt(0).toUpperCase()}${key.slice(1)}-Cookies`,
				description: ""
			})
		},
		trackingTechnologies: {
			heading: () => "Weitere Tracking-Technologien",
			intro: () => "Zusätzlich zu Cookies setzen wir möglicherweise die folgenden Tracking-Technologien ein:"
		},
		thirdParties: {
			heading: () => "Cookies von Drittanbietern",
			intro: () => "Folgende Dritte können über unsere Dienste Cookies setzen:",
			headers: () => [
				"Dienst",
				"Zweck",
				"Datenschutzerklärung"
			],
			linkText: () => "Anzeigen"
		},
		consent: {
			heading: () => "Ihre Einwilligung",
			banner: () => "Beim ersten Besuch unserer Dienste zeigen wir ein Cookie-Einwilligungsbanner an.",
			panel: () => "Sie können Ihre Cookie-Einstellungen jederzeit über unser Präferenzpanel verwalten.",
			withdraw: () => "Sie können Ihre Einwilligung jederzeit widerrufen; dies berührt jedoch nicht die Rechtmäßigkeit der bis zum Widerruf auf Grundlage der Einwilligung erfolgten Verarbeitung."
		},
		managing: {
			heading: () => "Verwaltung von Cookies",
			intro: () => "Die meisten Webbrowser ermöglichen es Ihnen, Cookies über ihre Einstellungen zu steuern. Sie können:",
			items: {
				delete: () => "Bereits auf Ihrem Gerät gespeicherte Cookies löschen",
				block: () => "Das Setzen von Cookies auf Ihrem Gerät blockieren",
				notify: () => "Ihren Browser so einstellen, dass er Sie benachrichtigt, wenn ein Cookie gesetzt wird"
			},
			footer: () => "Bitte beachten Sie, dass das Beschränken von Cookies die Funktionalität unserer Dienste beeinträchtigen kann. Eine Anleitung zur Verwaltung von Cookies finden Sie in der Hilfe-Dokumentation Ihres Browsers."
		},
		jurisdictionEuUk: {
			heading: {
				euAndUk: () => "Nutzer in der EU und im Vereinigten Königreich (DSGVO / UK-GDPR)",
				eu: () => "Nutzer in der Europäischen Union (DSGVO)",
				uk: () => "Nutzer im Vereinigten Königreich (UK-GDPR)"
			},
			body: ({ region }) => `Wenn Sie sich in ${region} befinden, stützen wir uns für das Setzen nicht-essenzieller Cookies auf Ihre Einwilligung als Rechtsgrundlage. Sie haben das Recht, Ihre Einwilligung jederzeit zu widerrufen.`,
			region: {
				euAndUk: () => "dem Europäischen Wirtschaftsraum oder im Vereinigten Königreich",
				eu: () => "dem Europäischen Wirtschaftsraum",
				uk: () => "dem Vereinigten Königreich"
			},
			essentialBody: () => "Essenzielle Cookies werden auf Grundlage unseres berechtigten Interesses gesetzt, Ihnen einen funktionierenden Dienst bereitzustellen."
		},
		contact: {
			heading: () => "Kontakt",
			intro: () => "Bei Fragen zu dieser Cookie-Richtlinie kontaktieren Sie uns bitte:"
		}
	}
};
//#endregion
//#region src/i18n/en.ts
const en = {
	shared: {
		versionSuffix: ({ version }) => ` Version: ${version}.`,
		contactLabels: {
			legalName: () => "Legal Name:",
			address: () => "Address:",
			email: () => "Email:",
			phone: () => "Phone:",
			dpo: () => "Data Protection Officer:"
		},
		legalBasisLabels: {
			consent: () => "Consent (Article 6(1)(a))",
			contract: () => "Performance of a contract (Article 6(1)(b))",
			legal_obligation: () => "Compliance with a legal obligation (Article 6(1)(c))",
			vital_interests: () => "Protection of vital interests (Article 6(1)(d))",
			public_task: () => "Performance of a public task (Article 6(1)(e))",
			legitimate_interests: () => "Legitimate interests (Article 6(1)(f))"
		}
	},
	privacy: {
		introduction: {
			heading: () => "Introduction",
			body: ({ companyName, effectiveDate, versionSuffix }) => `This Privacy Policy describes how ${companyName} ("we", "us", or "our") collects, uses, and shares information about you when you use our services. Effective Date: ${effectiveDate}.${versionSuffix}`,
			contactLine: ({ contactEmail }) => `If you have questions about this policy, please contact us at ${contactEmail}.`
		},
		childrenPrivacy: {
			heading: () => "Children's Privacy",
			body: ({ underAge }) => `Our services are not directed to children under the age of ${underAge}. We do not knowingly collect personal information from children under ${underAge}. If you believe we have collected information from a child, please contact us immediately.`,
			noticeLinkPrefix: () => "For more information, see our ",
			noticeLinkText: () => "Children's Privacy Notice"
		},
		dataCollected: {
			heading: () => "Information We Collect",
			intro: {
				withGdpr: () => "We collect the following categories of personal data for the purposes described below. Under GDPR Article 6, we rely on the lawful bases shown for each processing purpose:",
				withoutGdpr: () => "We collect the following categories of personal data for the purposes described below:"
			},
			headers: {
				withGdpr: () => [
					"Category",
					"Fields collected",
					"Purpose",
					"Lawful basis"
				],
				withoutGdpr: () => [
					"Category",
					"Fields collected",
					"Purpose"
				]
			}
		},
		consentWithdrawal: {
			heading: () => "Right to Withdraw Consent",
			body: ({ contactEmail }) => `Where we rely on your consent for any processing of your personal data, you have the right to withdraw that consent at any time by contacting us at ${contactEmail}. Withdrawing your consent does not affect the lawfulness of any processing we carried out before you withdrew it. Where consent is required to provide a particular feature or service, withdrawing it may mean we are no longer able to offer that feature or service.`
		},
		automatedDecisionMaking: {
			heading: () => "Automated Decision-Making and Profiling",
			empty: () => "We do not engage in automated decision-making or profiling that produces legal effects concerning you or similarly significantly affects you within the meaning of GDPR Article 22.",
			intro: () => "We use the following automated processing that may produce legal effects concerning you or similarly significantly affect you. For each, we describe the logic involved and the significance and envisaged consequences:",
			significanceLabel: () => "Significance:",
			humanReview: {
				label: () => "Right to human review.",
				body: ({ contactEmail }) => ` You have the right not to be subject to a decision based solely on automated processing, including profiling. To request human intervention, express your point of view, or contest a decision, contact us at ${contactEmail}.`
			}
		},
		dataRetention: {
			heading: () => "Data Retention",
			intro: () => "We retain your data for the following periods:",
			headers: () => ["Category", "Retention period"]
		},
		provisionRequirement: {
			heading: () => "Whether You Are Required to Provide This Data",
			body: () => "For each category of personal data we collect, we set out below whether you are required to provide it — by law, under our contract with you, or as a precondition to entering into a contract — or whether provision is voluntary, together with the consequences of failing to provide it.",
			headers: () => [
				"Category",
				"Requirement",
				"Consequences"
			]
		},
		cookies: {
			heading: () => "Cookies and Tracking",
			empty: () => "We do not use cookies or similar tracking technologies.",
			intro: () => "We use the following types of cookies and tracking technologies:",
			headers: () => ["Category", "Lawful basis"]
		},
		thirdParties: {
			heading: () => "Third-Party Services",
			empty: () => "We do not share your personal information with third parties except as required by law.",
			intro: () => "We share data with the following third-party services:",
			headers: () => [
				"Service",
				"Purpose",
				"Privacy policy"
			],
			linkText: () => "View"
		},
		userRights: {
			heading: () => "Your Rights",
			intro: () => "You have the following rights regarding your personal data:",
			labels: {
				access: () => "Right to access your personal data",
				rectification: () => "Right to correct inaccurate data",
				erasure: () => "Right to request deletion of your data",
				portability: () => "Right to receive your data in a portable format",
				restriction: () => "Right to restrict how we process your data",
				objection: () => "Right to object to processing",
				opt_out_sale: () => "Right to opt out of the sale of your personal information",
				non_discrimination: () => "Right to non-discriminatory treatment for exercising your rights"
			}
		},
		dpo: {
			present: { trailing: () => ". You may contact our Data Protection Officer directly with any questions about this policy or how we handle your personal data." },
			absentRequiredFalse: ({ reason }) => `We have not appointed a Data Protection Officer. Our processing activities do not meet the thresholds in GDPR Article 37(1) that would require one.${reason}`,
			absentFallback: () => "We have not appointed a Data Protection Officer. Our processing activities do not meet the thresholds in GDPR Article 37(1) that would require one. For any questions about this policy or how we handle your personal data, please use the contact details above."
		},
		euRepresentative: { body: ({ address, email }) => ({
			prefix: "Our representative in the European Union for the purposes of Article 27 GDPR is ",
			suffix: `, ${address}, ${email}.`
		}) },
		gdprSupplement: {
			heading: () => "GDPR Supplemental Disclosures",
			scope: () => "This section applies to individuals in the European Economic Area (EEA) under the General Data Protection Regulation (GDPR).",
			dataControllerLabel: () => "Data Controller: ",
			complaintBody: {
				prefix: () => "You have the right to lodge a complaint with the data protection supervisory authority in your country of residence, place of work, or place of the alleged infringement. A list of EEA supervisory authorities is available at ",
				linkText: () => "edpb.europa.eu/about-edpb/about-edpb/members_en",
				suffix: () => "."
			},
			transferBody: {
				prefix: () => "Where we transfer your personal data outside the EEA, we rely on one or more of the safeguards permitted under Chapter V of the GDPR: (a) transfers to countries the European Commission has determined provide an adequate level of data protection (the current list is published at ",
				adequacyLinkText: () => "commission.europa.eu/.../adequacy-decisions_en",
				middle: () => "); (b) Standard Contractual Clauses (SCCs) adopted by the European Commission under Article 46(2)(c); and (c) Binding Corporate Rules approved under Article 47 where applicable. You may request further information about the specific safeguards applied to a particular transfer by contacting us at ",
				email: ({ contactEmail }) => `${contactEmail}.`
			}
		},
		ukGdprSupplement: {
			heading: () => "UK Privacy Rights (UK-GDPR)",
			scope: () => "This section applies to individuals in the United Kingdom under the UK General Data Protection Regulation (UK-GDPR), as tailored by the Data Protection Act 2018.",
			dataControllerLabel: () => "Data Controller: ",
			ico: {
				prefix: () => "The supervisory authority for data protection in the UK is the ",
				label: () => "Information Commissioner's Office (ICO)",
				suffix: () => ". If you believe we have not handled your data in accordance with UK data protection law, you have the right to lodge a complaint with the ICO at ",
				linkText: () => "ico.org.uk/make-a-complaint",
				suffix2: () => "."
			},
			transferBody: () => "If we transfer your personal data outside the United Kingdom, we ensure appropriate safeguards are in place in accordance with the UK-GDPR, including the UK International Data Transfer Agreement or the UK Addendum to the EU Standard Contractual Clauses where applicable."
		},
		ccpaSupplement: {
			heading: () => "California Privacy Rights (CCPA)",
			intro: () => "If you are a California resident, you have the following additional rights:",
			rights: {
				know: () => "Right to Know — You may request disclosure of the personal information we collect, use, and share about you.",
				delete: () => "Right to Delete — You may request deletion of personal information we have collected about you.",
				optOut: () => "Right to Opt-Out — You may opt out of the sale of your personal information.",
				nonDiscrimination: () => "Right to Non-Discrimination — We will not discriminate against you for exercising your CCPA rights."
			},
			submitting: {
				label: () => "Submitting requests.",
				body: () => " To exercise any of these rights, contact us using one of the methods below. We will respond within the timeframes required by CCPA §1798.130."
			}
		},
		contact: {
			heading: () => "Contact Us",
			intro: () => "Contact us:"
		},
		provisionBasisLabels: {
			statutory: () => "Required by law",
			contractual: () => "Required under our contract with you",
			"contract-prerequisite": () => "Required to enter into a contract",
			voluntary: () => "Voluntary"
		},
		cookieCategoryLabels: {
			essential: () => "Essential cookies — required for the service to function",
			analytics: () => "Analytics cookies — help us understand how the service is used",
			functional: () => "Functional cookies — remember your preferences and settings",
			marketing: () => "Marketing cookies — used to deliver relevant advertisements"
		},
		cookieCategoryFallback: ({ key }) => `${key} cookies`
	},
	cookie: {
		introduction: {
			heading: () => "Cookie Policy",
			body: ({ companyName, effectiveDate, versionSuffix }) => `This Cookie Policy explains how ${companyName} ("we", "us", or "our") uses cookies and similar tracking technologies on our services. Effective Date: ${effectiveDate}.${versionSuffix}`
		},
		whatAreCookies: {
			heading: () => "What Are Cookies?",
			body1: () => "Cookies are small text files placed on your device by websites you visit. They are widely used to make websites work more efficiently and to provide information to site owners.",
			body2: () => "Cookies can be \"session cookies\" (deleted when you close your browser) or \"persistent cookies\" (remain on your device until they expire or you delete them)."
		},
		types: {
			heading: () => "Types of Cookies We Use",
			empty: () => "We do not currently use any cookies.",
			headers: () => ["Type", "Description"],
			labels: {
				essential: {
					label: () => "Essential Cookies",
					description: () => "Required for the basic functioning of our services. These cannot be disabled."
				},
				analytics: {
					label: () => "Analytics Cookies",
					description: () => "Help us understand how visitors interact with our services so we can improve them."
				},
				functional: {
					label: () => "Functional Cookies",
					description: () => "Enable enhanced functionality and personalisation, such as remembering your preferences."
				},
				marketing: {
					label: () => "Marketing Cookies",
					description: () => "Used to deliver advertisements more relevant to you and your interests."
				}
			},
			fallback: ({ key }) => ({
				label: `${key.charAt(0).toUpperCase()}${key.slice(1)} Cookies`,
				description: ""
			})
		},
		trackingTechnologies: {
			heading: () => "Other Tracking Technologies",
			intro: () => "In addition to cookies, we may use the following tracking technologies:"
		},
		thirdParties: {
			heading: () => "Third-Party Cookies",
			intro: () => "The following third parties may set cookies through our services:",
			headers: () => [
				"Service",
				"Purpose",
				"Privacy policy"
			],
			linkText: () => "View"
		},
		consent: {
			heading: () => "Your Consent",
			banner: () => "We display a cookie consent banner when you first visit our services.",
			panel: () => "You can manage your cookie preferences at any time via our preference panel.",
			withdraw: () => "You may withdraw your consent at any time; however, this will not affect the lawfulness of processing based on consent before its withdrawal."
		},
		managing: {
			heading: () => "Managing Cookies",
			intro: () => "Most web browsers allow you to control cookies through their settings. You can:",
			items: {
				delete: () => "Delete cookies already stored on your device",
				block: () => "Block cookies from being set on your device",
				notify: () => "Set your browser to notify you when a cookie is being set"
			},
			footer: () => "Please note that restricting cookies may impact the functionality of our services. Consult your browser's help documentation for instructions on managing cookies."
		},
		jurisdictionEuUk: {
			heading: {
				euAndUk: () => "European and UK Users (GDPR / UK-GDPR)",
				eu: () => "European Users (GDPR)",
				uk: () => "UK Users (UK-GDPR)"
			},
			body: ({ region }) => `If you are located in the ${region}, we rely on your consent as our legal basis for setting non-essential cookies. You have the right to withdraw consent at any time.`,
			region: {
				euAndUk: () => "European Economic Area or the United Kingdom",
				eu: () => "European Economic Area",
				uk: () => "United Kingdom"
			},
			essentialBody: () => "Essential cookies are set on the basis of our legitimate interests to provide you with a functioning service."
		},
		contact: {
			heading: () => "Contact Us",
			intro: () => "If you have questions about this Cookie Policy, please contact us:"
		}
	}
};
//#endregion
//#region src/i18n/es.ts
const es = {
	shared: {
		versionSuffix: ({ version }) => ` Versión: ${version}.`,
		contactLabels: {
			legalName: () => "Razón social:",
			address: () => "Dirección:",
			email: () => "Correo electrónico:",
			phone: () => "Teléfono:",
			dpo: () => "Delegado de Protección de Datos:"
		},
		legalBasisLabels: {
			consent: () => "Consentimiento (artículo 6, apartado 1, letra a) del RGPD)",
			contract: () => "Ejecución de un contrato (artículo 6, apartado 1, letra b) del RGPD)",
			legal_obligation: () => "Cumplimiento de una obligación legal (artículo 6, apartado 1, letra c) del RGPD)",
			vital_interests: () => "Protección de intereses vitales (artículo 6, apartado 1, letra d) del RGPD)",
			public_task: () => "Cumplimiento de una misión de interés público (artículo 6, apartado 1, letra e) del RGPD)",
			legitimate_interests: () => "Intereses legítimos (artículo 6, apartado 1, letra f) del RGPD)"
		}
	},
	privacy: {
		introduction: {
			heading: () => "Introducción",
			body: ({ companyName, effectiveDate, versionSuffix }) => `La presente Política de Privacidad describe cómo ${companyName} («nosotros», «nos» o «nuestro») recopila, utiliza y comparte información sobre usted cuando utiliza nuestros servicios. Fecha de entrada en vigor: ${effectiveDate}.${versionSuffix}`,
			contactLine: ({ contactEmail }) => `Si tiene preguntas sobre esta política, póngase en contacto con nosotros en ${contactEmail}.`
		},
		childrenPrivacy: {
			heading: () => "Privacidad de los menores",
			body: ({ underAge }) => `Nuestros servicios no están dirigidos a menores de ${underAge} años. No recopilamos a sabiendas datos personales de menores de ${underAge} años. Si cree que hemos recopilado información de un menor, póngase en contacto con nosotros de inmediato.`,
			noticeLinkPrefix: () => "Para más información, consulte nuestro ",
			noticeLinkText: () => "Aviso de privacidad para menores"
		},
		dataCollected: {
			heading: () => "Información que recopilamos",
			intro: {
				withGdpr: () => "Recopilamos las siguientes categorías de datos personales con las finalidades descritas a continuación. En virtud del artículo 6 del RGPD, nos basamos en las bases jurídicas indicadas para cada finalidad de tratamiento:",
				withoutGdpr: () => "Recopilamos las siguientes categorías de datos personales con las finalidades descritas a continuación:"
			},
			headers: {
				withGdpr: () => [
					"Categoría",
					"Campos recopilados",
					"Finalidad",
					"Base jurídica"
				],
				withoutGdpr: () => [
					"Categoría",
					"Campos recopilados",
					"Finalidad"
				]
			}
		},
		consentWithdrawal: {
			heading: () => "Derecho a retirar el consentimiento",
			body: ({ contactEmail }) => `Cuando nos basemos en su consentimiento para el tratamiento de sus datos personales, tiene derecho a retirar dicho consentimiento en cualquier momento poniéndose en contacto con nosotros en ${contactEmail}. La retirada de su consentimiento no afectará a la licitud del tratamiento realizado con anterioridad. Cuando el consentimiento sea necesario para prestar una determinada funcionalidad o servicio, su retirada puede implicar que ya no podamos ofrecerle dicha funcionalidad o servicio.`
		},
		automatedDecisionMaking: {
			heading: () => "Decisiones automatizadas y elaboración de perfiles",
			empty: () => "No realizamos decisiones automatizadas ni elaboración de perfiles que produzcan efectos jurídicos sobre usted o le afecten de modo similar de manera significativa, en el sentido del artículo 22 del RGPD.",
			intro: () => "Utilizamos los siguientes tratamientos automatizados que pueden producir efectos jurídicos sobre usted o afectarle de modo similar de manera significativa. Para cada uno describimos la lógica aplicada y la importancia y consecuencias previstas:",
			significanceLabel: () => "Importancia:",
			humanReview: {
				label: () => "Derecho a la intervención humana.",
				body: ({ contactEmail }) => ` Tiene derecho a no ser objeto de una decisión basada únicamente en el tratamiento automatizado, incluida la elaboración de perfiles. Para solicitar intervención humana, expresar su punto de vista o impugnar una decisión, póngase en contacto con nosotros en ${contactEmail}.`
			}
		},
		dataRetention: {
			heading: () => "Conservación de los datos",
			intro: () => "Conservamos sus datos durante los siguientes plazos:",
			headers: () => ["Categoría", "Plazo de conservación"]
		},
		provisionRequirement: {
			heading: () => "Carácter obligatorio o facultativo de la facilitación de los datos",
			body: () => "Para cada categoría de datos personales que recopilamos, indicamos a continuación si está obligado/a a facilitarlos — por ley, en virtud de nuestro contrato con usted o como condición previa a la celebración de un contrato — o si su facilitación es voluntaria, así como las consecuencias de no facilitarlos.",
			headers: () => [
				"Categoría",
				"Carácter",
				"Consecuencias"
			]
		},
		cookies: {
			heading: () => "Cookies y seguimiento",
			empty: () => "No utilizamos cookies ni tecnologías de seguimiento similares.",
			intro: () => "Utilizamos los siguientes tipos de cookies y tecnologías de seguimiento:",
			headers: () => ["Categoría", "Base jurídica"]
		},
		thirdParties: {
			heading: () => "Servicios de terceros",
			empty: () => "No compartimos sus datos personales con terceros, salvo cuando la ley lo exija.",
			intro: () => "Compartimos datos con los siguientes servicios de terceros:",
			headers: () => [
				"Servicio",
				"Finalidad",
				"Política de privacidad"
			],
			linkText: () => "Consultar"
		},
		userRights: {
			heading: () => "Sus derechos",
			intro: () => "Dispone de los siguientes derechos en relación con sus datos personales:",
			labels: {
				access: () => "Derecho de acceso a sus datos personales",
				rectification: () => "Derecho de rectificación de datos inexactos",
				erasure: () => "Derecho de supresión de sus datos",
				portability: () => "Derecho a la portabilidad de sus datos",
				restriction: () => "Derecho a la limitación del tratamiento",
				objection: () => "Derecho de oposición al tratamiento",
				opt_out_sale: () => "Derecho a oponerse a la venta de su información personal",
				non_discrimination: () => "Derecho a un trato no discriminatorio por el ejercicio de sus derechos"
			}
		},
		dpo: {
			present: { trailing: () => ". Puede dirigirse directamente a nuestro Delegado de Protección de Datos para cualquier consulta sobre la presente política o sobre cómo tratamos sus datos personales." },
			absentRequiredFalse: ({ reason }) => `No hemos designado un Delegado de Protección de Datos. Nuestras actividades de tratamiento no alcanzan los umbrales del artículo 37, apartado 1, del RGPD que exigirían su designación.${reason}`,
			absentFallback: () => "No hemos designado un Delegado de Protección de Datos. Nuestras actividades de tratamiento no alcanzan los umbrales del artículo 37, apartado 1, del RGPD que exigirían su designación. Para cualquier consulta sobre la presente política o sobre cómo tratamos sus datos personales, utilice los datos de contacto indicados anteriormente."
		},
		euRepresentative: { body: ({ address, email }) => ({
			prefix: "Nuestro representante en la Unión Europea a los efectos del artículo 27 del RGPD es ",
			suffix: `, ${address}, ${email}.`
		}) },
		gdprSupplement: {
			heading: () => "Información complementaria del RGPD",
			scope: () => "Esta sección se aplica a las personas situadas en el Espacio Económico Europeo (EEE) en virtud del Reglamento General de Protección de Datos (RGPD).",
			dataControllerLabel: () => "Responsable del tratamiento: ",
			complaintBody: {
				prefix: () => "Tiene derecho a presentar una reclamación ante la autoridad de control de protección de datos de su país de residencia, lugar de trabajo o del lugar de la presunta infracción. La lista de autoridades de control del EEE está disponible en ",
				linkText: () => "edpb.europa.eu/about-edpb/about-edpb/members_en",
				suffix: () => "."
			},
			transferBody: {
				prefix: () => "Cuando transferimos sus datos personales fuera del EEE, nos basamos en una o varias de las garantías previstas en el capítulo V del RGPD: (a) transferencias a países sobre los que la Comisión Europea haya adoptado una decisión de adecuación (la lista actualizada se publica en ",
				adequacyLinkText: () => "commission.europa.eu/.../adequacy-decisions_en",
				middle: () => "); (b) Cláusulas Contractuales Tipo (CCT) adoptadas por la Comisión Europea con arreglo al artículo 46, apartado 2, letra c); y (c) Normas Corporativas Vinculantes (NCV) aprobadas en virtud del artículo 47, cuando proceda. Puede solicitar más información sobre las garantías específicas aplicadas a una transferencia concreta poniéndose en contacto con nosotros en ",
				email: ({ contactEmail }) => `${contactEmail}.`
			}
		},
		ukGdprSupplement: {
			heading: () => "Derechos de privacidad en el Reino Unido (UK-GDPR)",
			scope: () => "Esta sección se aplica a las personas situadas en el Reino Unido en virtud del UK General Data Protection Regulation (UK-GDPR), adaptado por la Data Protection Act 2018.",
			dataControllerLabel: () => "Responsable del tratamiento: ",
			ico: {
				prefix: () => "La autoridad de control de protección de datos en el Reino Unido es la ",
				label: () => "Information Commissioner's Office (ICO)",
				suffix: () => ". Si considera que no hemos tratado sus datos conforme al derecho británico de protección de datos, tiene derecho a presentar una reclamación ante la ICO en ",
				linkText: () => "ico.org.uk/make-a-complaint",
				suffix2: () => "."
			},
			transferBody: () => "Cuando transferimos sus datos personales fuera del Reino Unido, garantizamos la existencia de salvaguardias adecuadas conforme al UK-GDPR, incluidos el UK International Data Transfer Agreement o el UK Addendum a las Cláusulas Contractuales Tipo de la UE, cuando proceda."
		},
		ccpaSupplement: {
			heading: () => "Derechos de privacidad en California (CCPA)",
			intro: () => "Si reside en California, dispone de los siguientes derechos adicionales:",
			rights: {
				know: () => "Derecho a saber — Puede solicitar la divulgación de la información personal que recopilamos, utilizamos y compartimos sobre usted.",
				delete: () => "Derecho de supresión — Puede solicitar la supresión de la información personal que hayamos recopilado sobre usted.",
				optOut: () => "Derecho de oposición a la venta — Puede oponerse a la venta de su información personal.",
				nonDiscrimination: () => "Derecho a no ser discriminado — No le discriminaremos por ejercer sus derechos CCPA."
			},
			submitting: {
				label: () => "Presentación de solicitudes.",
				body: () => " Para ejercer cualquiera de estos derechos, póngase en contacto con nosotros mediante uno de los métodos indicados a continuación. Responderemos dentro de los plazos exigidos por la sección 1798.130 del CCPA."
			}
		},
		contact: {
			heading: () => "Contacto",
			intro: () => "Póngase en contacto con nosotros:"
		},
		provisionBasisLabels: {
			statutory: () => "Obligatorio por ley",
			contractual: () => "Obligatorio en virtud del contrato",
			"contract-prerequisite": () => "Condición previa para la celebración de un contrato",
			voluntary: () => "Voluntario"
		},
		cookieCategoryLabels: {
			essential: () => "Cookies esenciales — necesarias para el funcionamiento del servicio",
			analytics: () => "Cookies analíticas — nos ayudan a entender cómo se utiliza el servicio",
			functional: () => "Cookies funcionales — recuerdan sus preferencias y ajustes",
			marketing: () => "Cookies de marketing — utilizadas para mostrar publicidad relevante"
		},
		cookieCategoryFallback: ({ key }) => `Cookies de ${key}`
	},
	cookie: {
		introduction: {
			heading: () => "Política de cookies",
			body: ({ companyName, effectiveDate, versionSuffix }) => `La presente Política de Cookies explica cómo ${companyName} («nosotros», «nos» o «nuestro») utiliza cookies y tecnologías de seguimiento similares en nuestros servicios. Fecha de entrada en vigor: ${effectiveDate}.${versionSuffix}`
		},
		whatAreCookies: {
			heading: () => "¿Qué son las cookies?",
			body1: () => "Las cookies son pequeños archivos de texto que se colocan en su dispositivo desde los sitios web que visita. Se utilizan ampliamente para que los sitios funcionen de forma más eficiente y para proporcionar información a sus propietarios.",
			body2: () => "Las cookies pueden ser «de sesión» (se eliminan al cerrar el navegador) o «persistentes» (permanecen en su dispositivo hasta que caducan o las elimina)."
		},
		types: {
			heading: () => "Tipos de cookies que utilizamos",
			empty: () => "Actualmente no utilizamos cookies.",
			headers: () => ["Tipo", "Descripción"],
			labels: {
				essential: {
					label: () => "Cookies esenciales",
					description: () => "Necesarias para el funcionamiento básico de nuestros servicios. No pueden desactivarse."
				},
				analytics: {
					label: () => "Cookies analíticas",
					description: () => "Nos ayudan a entender cómo interactúan los visitantes con nuestros servicios para poder mejorarlos."
				},
				functional: {
					label: () => "Cookies funcionales",
					description: () => "Permiten una funcionalidad mejorada y la personalización, como recordar sus preferencias."
				},
				marketing: {
					label: () => "Cookies de marketing",
					description: () => "Utilizadas para mostrarle anuncios más relevantes para usted y sus intereses."
				}
			},
			fallback: ({ key }) => ({
				label: `Cookies de ${key}`,
				description: ""
			})
		},
		trackingTechnologies: {
			heading: () => "Otras tecnologías de seguimiento",
			intro: () => "Además de cookies, podemos utilizar las siguientes tecnologías de seguimiento:"
		},
		thirdParties: {
			heading: () => "Cookies de terceros",
			intro: () => "Los siguientes terceros pueden establecer cookies a través de nuestros servicios:",
			headers: () => [
				"Servicio",
				"Finalidad",
				"Política de privacidad"
			],
			linkText: () => "Consultar"
		},
		consent: {
			heading: () => "Su consentimiento",
			banner: () => "Mostramos un banner de consentimiento de cookies en su primera visita a nuestros servicios.",
			panel: () => "Puede gestionar sus preferencias de cookies en cualquier momento a través de nuestro panel de preferencias.",
			withdraw: () => "Puede retirar su consentimiento en cualquier momento; no obstante, ello no afectará a la licitud del tratamiento basado en el consentimiento previo a la retirada."
		},
		managing: {
			heading: () => "Gestión de cookies",
			intro: () => "La mayoría de los navegadores web le permiten controlar las cookies a través de sus ajustes. Puede:",
			items: {
				delete: () => "Eliminar las cookies ya almacenadas en su dispositivo",
				block: () => "Bloquear el establecimiento de cookies en su dispositivo",
				notify: () => "Configurar su navegador para que le notifique cuando se establezca una cookie"
			},
			footer: () => "Tenga en cuenta que restringir las cookies puede afectar a la funcionalidad de nuestros servicios. Consulte la documentación de ayuda de su navegador para obtener instrucciones sobre la gestión de cookies."
		},
		jurisdictionEuUk: {
			heading: {
				euAndUk: () => "Usuarios de la UE y del Reino Unido (RGPD / UK-GDPR)",
				eu: () => "Usuarios de la Unión Europea (RGPD)",
				uk: () => "Usuarios del Reino Unido (UK-GDPR)"
			},
			body: ({ region }) => `Si se encuentra en ${region}, nos basamos en su consentimiento como base jurídica para la instalación de cookies no esenciales. Tiene derecho a retirar su consentimiento en cualquier momento.`,
			region: {
				euAndUk: () => "el Espacio Económico Europeo o el Reino Unido",
				eu: () => "el Espacio Económico Europeo",
				uk: () => "el Reino Unido"
			},
			essentialBody: () => "Las cookies esenciales se instalan sobre la base de nuestro interés legítimo en ofrecerle un servicio operativo."
		},
		contact: {
			heading: () => "Contacto",
			intro: () => "Si tiene preguntas sobre esta Política de Cookies, póngase en contacto con nosotros:"
		}
	}
};
//#endregion
//#region src/i18n/fr.ts
const fr = {
	shared: {
		versionSuffix: ({ version }) => ` Version : ${version}.`,
		contactLabels: {
			legalName: () => "Raison sociale :",
			address: () => "Adresse :",
			email: () => "E-mail :",
			phone: () => "Téléphone :",
			dpo: () => "Délégué à la protection des données :"
		},
		legalBasisLabels: {
			consent: () => "Consentement (article 6, paragraphe 1, point a))",
			contract: () => "Exécution d'un contrat (article 6, paragraphe 1, point b))",
			legal_obligation: () => "Respect d'une obligation légale (article 6, paragraphe 1, point c))",
			vital_interests: () => "Sauvegarde des intérêts vitaux (article 6, paragraphe 1, point d))",
			public_task: () => "Exécution d'une mission d'intérêt public (article 6, paragraphe 1, point e))",
			legitimate_interests: () => "Intérêts légitimes (article 6, paragraphe 1, point f))"
		}
	},
	privacy: {
		introduction: {
			heading: () => "Introduction",
			body: ({ companyName, effectiveDate, versionSuffix }) => `La présente politique de confidentialité décrit la manière dont ${companyName} (« nous », « notre » ou « nos ») collecte, utilise et partage les informations vous concernant lorsque vous utilisez nos services. Date d'entrée en vigueur : ${effectiveDate}.${versionSuffix}`,
			contactLine: ({ contactEmail }) => `Si vous avez des questions concernant la présente politique, veuillez nous contacter à l'adresse ${contactEmail}.`
		},
		childrenPrivacy: {
			heading: () => "Vie privée des enfants",
			body: ({ underAge }) => `Nos services ne sont pas destinés aux enfants âgés de moins de ${underAge} ans. Nous ne collectons pas sciemment de données à caractère personnel auprès d'enfants de moins de ${underAge} ans. Si vous pensez que nous avons collecté des informations concernant un enfant, veuillez nous contacter immédiatement.`,
			noticeLinkPrefix: () => "Pour plus d'informations, consultez notre ",
			noticeLinkText: () => "Avis de confidentialité destiné aux enfants"
		},
		dataCollected: {
			heading: () => "Données que nous collectons",
			intro: {
				withGdpr: () => "Nous collectons les catégories de données à caractère personnel ci-dessous aux fins décrites. En application de l'article 6 du RGPD, nous nous appuyons sur les bases légales indiquées pour chaque finalité de traitement :",
				withoutGdpr: () => "Nous collectons les catégories de données à caractère personnel ci-dessous aux fins décrites :"
			},
			headers: {
				withGdpr: () => [
					"Catégorie",
					"Champs collectés",
					"Finalité",
					"Base légale"
				],
				withoutGdpr: () => [
					"Catégorie",
					"Champs collectés",
					"Finalité"
				]
			}
		},
		consentWithdrawal: {
			heading: () => "Droit de retirer son consentement",
			body: ({ contactEmail }) => `Lorsque nous nous appuyons sur votre consentement pour traiter vos données à caractère personnel, vous avez le droit de retirer ce consentement à tout moment en nous contactant à l'adresse ${contactEmail}. Le retrait de votre consentement n'affecte pas la licéité du traitement effectué avant ce retrait. Lorsque le consentement est requis pour fournir une fonctionnalité ou un service particulier, son retrait peut signifier que nous ne sommes plus en mesure de proposer cette fonctionnalité ou ce service.`
		},
		automatedDecisionMaking: {
			heading: () => "Décision automatisée et profilage",
			empty: () => "Nous n'effectuons pas de prise de décision automatisée ni de profilage produisant à votre égard des effets juridiques ou vous affectant de manière significative de façon similaire, au sens de l'article 22 du RGPD.",
			intro: () => "Nous utilisons les traitements automatisés suivants pouvant produire à votre égard des effets juridiques ou vous affecter de manière significative de façon similaire. Pour chacun, nous décrivons la logique sous-jacente ainsi que l'importance et les conséquences prévues :",
			significanceLabel: () => "Importance :",
			humanReview: {
				label: () => "Droit à une intervention humaine.",
				body: ({ contactEmail }) => ` Vous avez le droit de ne pas faire l'objet d'une décision fondée exclusivement sur un traitement automatisé, y compris le profilage. Pour demander une intervention humaine, exprimer votre point de vue ou contester une décision, contactez-nous à l'adresse ${contactEmail}.`
			}
		},
		dataRetention: {
			heading: () => "Conservation des données",
			intro: () => "Nous conservons vos données pendant les durées suivantes :",
			headers: () => ["Catégorie", "Durée de conservation"]
		},
		provisionRequirement: {
			heading: () => "Caractère obligatoire ou facultatif de la fourniture des données",
			body: () => "Pour chaque catégorie de données à caractère personnel que nous collectons, nous indiquons ci-dessous si vous êtes tenu(e) de la fournir — en vertu de la loi, de notre contrat avec vous, ou en tant que condition préalable à la conclusion d'un contrat — ou si sa fourniture est facultative, ainsi que les conséquences d'un défaut de fourniture.",
			headers: () => [
				"Catégorie",
				"Caractère",
				"Conséquences"
			]
		},
		cookies: {
			heading: () => "Cookies et technologies de suivi",
			empty: () => "Nous n'utilisons pas de cookies ni de technologies de suivi similaires.",
			intro: () => "Nous utilisons les types de cookies et de technologies de suivi suivants :",
			headers: () => ["Catégorie", "Base légale"]
		},
		thirdParties: {
			heading: () => "Services tiers",
			empty: () => "Nous ne partageons pas vos informations personnelles avec des tiers, sauf si la loi l'exige.",
			intro: () => "Nous partageons des données avec les services tiers suivants :",
			headers: () => [
				"Service",
				"Finalité",
				"Politique de confidentialité"
			],
			linkText: () => "Consulter"
		},
		userRights: {
			heading: () => "Vos droits",
			intro: () => "Vous disposez des droits suivants concernant vos données à caractère personnel :",
			labels: {
				access: () => "Droit d'accès à vos données à caractère personnel",
				rectification: () => "Droit de rectification des données inexactes",
				erasure: () => "Droit à l'effacement de vos données",
				portability: () => "Droit à la portabilité de vos données",
				restriction: () => "Droit à la limitation du traitement",
				objection: () => "Droit d'opposition au traitement",
				opt_out_sale: () => "Droit de refuser la vente de vos informations personnelles",
				non_discrimination: () => "Droit à un traitement non discriminatoire pour l'exercice de vos droits"
			}
		},
		dpo: {
			present: { trailing: () => ". Vous pouvez contacter directement notre Délégué à la protection des données pour toute question relative à la présente politique ou à la manière dont nous traitons vos données à caractère personnel." },
			absentRequiredFalse: ({ reason }) => `Nous n'avons pas désigné de Délégué à la protection des données. Nos activités de traitement n'atteignent pas les seuils prévus à l'article 37, paragraphe 1, du RGPD imposant cette désignation.${reason}`,
			absentFallback: () => "Nous n'avons pas désigné de Délégué à la protection des données. Nos activités de traitement n'atteignent pas les seuils prévus à l'article 37, paragraphe 1, du RGPD imposant cette désignation. Pour toute question relative à la présente politique ou à la manière dont nous traitons vos données à caractère personnel, veuillez utiliser les coordonnées ci-dessus."
		},
		euRepresentative: { body: ({ address, email }) => ({
			prefix: "Notre représentant dans l'Union européenne au sens de l'article 27 du RGPD est ",
			suffix: `, ${address}, ${email}.`
		}) },
		gdprSupplement: {
			heading: () => "Informations complémentaires RGPD",
			scope: () => "La présente section s'applique aux personnes situées dans l'Espace économique européen (EEE) au titre du Règlement général sur la protection des données (RGPD).",
			dataControllerLabel: () => "Responsable du traitement : ",
			complaintBody: {
				prefix: () => "Vous avez le droit d'introduire une réclamation auprès de l'autorité de contrôle de la protection des données de votre pays de résidence, de votre lieu de travail ou du lieu de la violation présumée. La liste des autorités de contrôle de l'EEE est disponible à l'adresse ",
				linkText: () => "edpb.europa.eu/about-edpb/about-edpb/members_en",
				suffix: () => "."
			},
			transferBody: {
				prefix: () => "Lorsque nous transférons vos données à caractère personnel hors de l'EEE, nous nous appuyons sur l'une ou plusieurs des garanties prévues au chapitre V du RGPD : (a) les transferts vers des pays bénéficiant d'une décision d'adéquation de la Commission européenne (la liste à jour est publiée à l'adresse ",
				adequacyLinkText: () => "commission.europa.eu/.../adequacy-decisions_en",
				middle: () => ") ; (b) les Clauses contractuelles types (CCT) adoptées par la Commission européenne en application de l'article 46, paragraphe 2, point c) ; et (c) les Règles d'entreprise contraignantes (BCR) approuvées au titre de l'article 47, le cas échéant. Vous pouvez demander des informations complémentaires sur les garanties spécifiques appliquées à un transfert particulier en nous contactant à l'adresse ",
				email: ({ contactEmail }) => `${contactEmail}.`
			}
		},
		ukGdprSupplement: {
			heading: () => "Droits relatifs à la vie privée au Royaume-Uni (UK-GDPR)",
			scope: () => "La présente section s'applique aux personnes situées au Royaume-Uni au titre du règlement UK-GDPR, tel qu'adapté par le Data Protection Act 2018.",
			dataControllerLabel: () => "Responsable du traitement : ",
			ico: {
				prefix: () => "L'autorité de contrôle de la protection des données au Royaume-Uni est l'",
				label: () => "Information Commissioner's Office (ICO)",
				suffix: () => ". Si vous estimez que nous n'avons pas traité vos données conformément au droit britannique de la protection des données, vous avez le droit d'introduire une réclamation auprès de l'ICO à l'adresse ",
				linkText: () => "ico.org.uk/make-a-complaint",
				suffix2: () => "."
			},
			transferBody: () => "Si nous transférons vos données à caractère personnel hors du Royaume-Uni, nous veillons à ce que des garanties appropriées soient en place conformément au UK-GDPR, notamment l'accord international de transfert de données du Royaume-Uni (IDTA) ou l'avenant britannique aux clauses contractuelles types de l'UE, le cas échéant."
		},
		ccpaSupplement: {
			heading: () => "Droits relatifs à la vie privée en Californie (CCPA)",
			intro: () => "Si vous résidez en Californie, vous disposez des droits supplémentaires suivants :",
			rights: {
				know: () => "Droit à l'information — Vous pouvez demander la communication des informations personnelles que nous collectons, utilisons et partageons à votre sujet.",
				delete: () => "Droit à la suppression — Vous pouvez demander la suppression des informations personnelles que nous avons collectées à votre sujet.",
				optOut: () => "Droit d'opposition à la vente — Vous pouvez vous opposer à la vente de vos informations personnelles.",
				nonDiscrimination: () => "Droit à la non-discrimination — Nous ne vous traiterons pas de manière discriminatoire pour l'exercice de vos droits CCPA."
			},
			submitting: {
				label: () => "Soumission des demandes.",
				body: () => " Pour exercer l'un de ces droits, contactez-nous via l'une des méthodes indiquées ci-dessous. Nous répondrons dans les délais prévus par la section 1798.130 du CCPA."
			}
		},
		contact: {
			heading: () => "Nous contacter",
			intro: () => "Nous contacter :"
		},
		provisionBasisLabels: {
			statutory: () => "Imposé par la loi",
			contractual: () => "Imposé par notre contrat avec vous",
			"contract-prerequisite": () => "Préalable à la conclusion d'un contrat",
			voluntary: () => "Facultatif"
		},
		cookieCategoryLabels: {
			essential: () => "Cookies essentiels — requis pour le fonctionnement du service",
			analytics: () => "Cookies d'analyse — nous aident à comprendre comment le service est utilisé",
			functional: () => "Cookies fonctionnels — mémorisent vos préférences et paramètres",
			marketing: () => "Cookies marketing — utilisés pour diffuser des publicités pertinentes"
		},
		cookieCategoryFallback: ({ key }) => `Cookies ${key}`
	},
	cookie: {
		introduction: {
			heading: () => "Politique relative aux cookies",
			body: ({ companyName, effectiveDate, versionSuffix }) => `La présente politique relative aux cookies explique comment ${companyName} (« nous », « notre » ou « nos ») utilise les cookies et les technologies de suivi similaires sur nos services. Date d'entrée en vigueur : ${effectiveDate}.${versionSuffix}`
		},
		whatAreCookies: {
			heading: () => "Qu'est-ce qu'un cookie ?",
			body1: () => "Les cookies sont de petits fichiers texte déposés sur votre appareil par les sites web que vous visitez. Ils sont largement utilisés pour faire fonctionner les sites plus efficacement et fournir des informations à leurs propriétaires.",
			body2: () => "Les cookies peuvent être « de session » (supprimés à la fermeture de votre navigateur) ou « persistants » (conservés sur votre appareil jusqu'à leur expiration ou suppression)."
		},
		types: {
			heading: () => "Types de cookies que nous utilisons",
			empty: () => "Nous n'utilisons actuellement aucun cookie.",
			headers: () => ["Type", "Description"],
			labels: {
				essential: {
					label: () => "Cookies essentiels",
					description: () => "Requis pour le fonctionnement de base de nos services. Ils ne peuvent pas être désactivés."
				},
				analytics: {
					label: () => "Cookies d'analyse",
					description: () => "Nous aident à comprendre comment les visiteurs interagissent avec nos services afin de les améliorer."
				},
				functional: {
					label: () => "Cookies fonctionnels",
					description: () => "Activent une fonctionnalité améliorée et la personnalisation, comme la mémorisation de vos préférences."
				},
				marketing: {
					label: () => "Cookies marketing",
					description: () => "Utilisés pour diffuser des publicités plus pertinentes pour vous et vos centres d'intérêt."
				}
			},
			fallback: ({ key }) => ({
				label: `Cookies ${key}`,
				description: ""
			})
		},
		trackingTechnologies: {
			heading: () => "Autres technologies de suivi",
			intro: () => "Outre les cookies, nous pouvons utiliser les technologies de suivi suivantes :"
		},
		thirdParties: {
			heading: () => "Cookies tiers",
			intro: () => "Les tiers suivants sont susceptibles de déposer des cookies via nos services :",
			headers: () => [
				"Service",
				"Finalité",
				"Politique de confidentialité"
			],
			linkText: () => "Consulter"
		},
		consent: {
			heading: () => "Votre consentement",
			banner: () => "Nous affichons une bannière de consentement aux cookies lors de votre première visite sur nos services.",
			panel: () => "Vous pouvez gérer vos préférences en matière de cookies à tout moment via notre panneau de préférences.",
			withdraw: () => "Vous pouvez retirer votre consentement à tout moment ; toutefois, cela n'affectera pas la licéité du traitement fondé sur le consentement effectué avant ce retrait."
		},
		managing: {
			heading: () => "Gestion des cookies",
			intro: () => "La plupart des navigateurs web vous permettent de contrôler les cookies via leurs paramètres. Vous pouvez :",
			items: {
				delete: () => "Supprimer les cookies déjà stockés sur votre appareil",
				block: () => "Bloquer le dépôt de cookies sur votre appareil",
				notify: () => "Configurer votre navigateur pour qu'il vous avertisse lorsqu'un cookie est déposé"
			},
			footer: () => "Veuillez noter que la restriction des cookies peut affecter la fonctionnalité de nos services. Consultez la documentation d'aide de votre navigateur pour obtenir des instructions sur la gestion des cookies."
		},
		jurisdictionEuUk: {
			heading: {
				euAndUk: () => "Utilisateurs de l'Union européenne et du Royaume-Uni (RGPD / UK-GDPR)",
				eu: () => "Utilisateurs de l'Union européenne (RGPD)",
				uk: () => "Utilisateurs du Royaume-Uni (UK-GDPR)"
			},
			body: ({ region }) => `Si vous résidez dans ${region}, nous nous appuyons sur votre consentement comme base légale pour le dépôt de cookies non essentiels. Vous avez le droit de retirer votre consentement à tout moment.`,
			region: {
				euAndUk: () => "l'Espace économique européen ou le Royaume-Uni",
				eu: () => "l'Espace économique européen",
				uk: () => "le Royaume-Uni"
			},
			essentialBody: () => "Les cookies essentiels sont déposés au titre de notre intérêt légitime à vous fournir un service fonctionnel."
		},
		contact: {
			heading: () => "Nous contacter",
			intro: () => "Si vous avez des questions concernant la présente politique relative aux cookies, veuillez nous contacter :"
		}
	}
};
//#endregion
//#region src/i18n/nl.ts
const nl = {
	shared: {
		versionSuffix: ({ version }) => ` Versie: ${version}.`,
		contactLabels: {
			legalName: () => "Bedrijfsnaam:",
			address: () => "Adres:",
			email: () => "E-mail:",
			phone: () => "Telefoon:",
			dpo: () => "Functionaris voor gegevensbescherming:"
		},
		legalBasisLabels: {
			consent: () => "Toestemming (artikel 6, lid 1, onder a) AVG)",
			contract: () => "Uitvoering van een overeenkomst (artikel 6, lid 1, onder b) AVG)",
			legal_obligation: () => "Naleving van een wettelijke verplichting (artikel 6, lid 1, onder c) AVG)",
			vital_interests: () => "Bescherming van vitale belangen (artikel 6, lid 1, onder d) AVG)",
			public_task: () => "Vervulling van een taak van algemeen belang (artikel 6, lid 1, onder e) AVG)",
			legitimate_interests: () => "Gerechtvaardigde belangen (artikel 6, lid 1, onder f) AVG)"
		}
	},
	privacy: {
		introduction: {
			heading: () => "Inleiding",
			body: ({ companyName, effectiveDate, versionSuffix }) => `Dit privacybeleid beschrijft hoe ${companyName} ('wij', 'ons' of 'onze') informatie over u verzamelt, gebruikt en deelt wanneer u onze diensten gebruikt. Ingangsdatum: ${effectiveDate}.${versionSuffix}`,
			contactLine: ({ contactEmail }) => `Als u vragen heeft over dit beleid, neem dan contact met ons op via ${contactEmail}.`
		},
		childrenPrivacy: {
			heading: () => "Privacy van kinderen",
			body: ({ underAge }) => `Onze diensten zijn niet gericht op kinderen onder de ${underAge} jaar. Wij verzamelen niet bewust persoonsgegevens van kinderen onder de ${underAge} jaar. Als u vermoedt dat wij informatie over een kind hebben verzameld, neem dan onmiddellijk contact met ons op.`,
			noticeLinkPrefix: () => "Raadpleeg voor meer informatie onze ",
			noticeLinkText: () => "privacyverklaring voor kinderen"
		},
		dataCollected: {
			heading: () => "Welke gegevens wij verzamelen",
			intro: {
				withGdpr: () => "Wij verzamelen de volgende categorieën persoonsgegevens voor de hieronder beschreven doeleinden. Op grond van artikel 6 AVG beroepen wij ons voor elk verwerkingsdoel op de aangegeven rechtsgronden:",
				withoutGdpr: () => "Wij verzamelen de volgende categorieën persoonsgegevens voor de hieronder beschreven doeleinden:"
			},
			headers: {
				withGdpr: () => [
					"Categorie",
					"Verzamelde velden",
					"Doel",
					"Rechtsgrond"
				],
				withoutGdpr: () => [
					"Categorie",
					"Verzamelde velden",
					"Doel"
				]
			}
		},
		consentWithdrawal: {
			heading: () => "Recht om toestemming in te trekken",
			body: ({ contactEmail }) => `Voor zover wij ons voor de verwerking van uw persoonsgegevens beroepen op uw toestemming, heeft u te allen tijde het recht deze toestemming in te trekken door contact met ons op te nemen via ${contactEmail}. Het intrekken van uw toestemming doet geen afbreuk aan de rechtmatigheid van de verwerking die heeft plaatsgevonden vóór de intrekking. Wanneer toestemming vereist is om een bepaalde functie of dienst te leveren, kan intrekking ervan betekenen dat wij die functie of dienst niet meer kunnen aanbieden.`
		},
		automatedDecisionMaking: {
			heading: () => "Geautomatiseerde besluitvorming en profilering",
			empty: () => "Wij voeren geen geautomatiseerde besluitvorming of profilering uit die ten aanzien van u rechtsgevolgen heeft of u op vergelijkbare wijze aanmerkelijk treft in de zin van artikel 22 AVG.",
			intro: () => "Wij gebruiken de volgende geautomatiseerde verwerkingen die ten aanzien van u rechtsgevolgen kunnen hebben of u op vergelijkbare wijze aanmerkelijk kunnen treffen. Voor elke verwerking beschrijven wij de onderliggende logica, het belang en de verwachte gevolgen:",
			significanceLabel: () => "Belang:",
			humanReview: {
				label: () => "Recht op menselijke tussenkomst.",
				body: ({ contactEmail }) => ` U heeft het recht niet te worden onderworpen aan een uitsluitend op geautomatiseerde verwerking, waaronder profilering, gebaseerd besluit. Om menselijke tussenkomst te verzoeken, uw standpunt kenbaar te maken of een besluit aan te vechten, neemt u contact met ons op via ${contactEmail}.`
			}
		},
		dataRetention: {
			heading: () => "Bewaartermijnen",
			intro: () => "Wij bewaren uw gegevens gedurende de volgende perioden:",
			headers: () => ["Categorie", "Bewaartermijn"]
		},
		provisionRequirement: {
			heading: () => "Verplicht of vrijwillig karakter van het verstrekken van gegevens",
			body: () => "Voor elke categorie persoonsgegevens die wij verzamelen, geven wij hieronder aan of u verplicht bent deze te verstrekken — op grond van de wet, op grond van onze overeenkomst met u, of als voorwaarde voor het sluiten van een overeenkomst — dan wel of de verstrekking vrijwillig is, alsmede de gevolgen van niet-verstrekking.",
			headers: () => [
				"Categorie",
				"Karakter",
				"Gevolgen"
			]
		},
		cookies: {
			heading: () => "Cookies en tracking",
			empty: () => "Wij gebruiken geen cookies of vergelijkbare trackingtechnologieën.",
			intro: () => "Wij gebruiken de volgende typen cookies en trackingtechnologieën:",
			headers: () => ["Categorie", "Rechtsgrond"]
		},
		thirdParties: {
			heading: () => "Diensten van derden",
			empty: () => "Wij delen uw persoonsgegevens niet met derden, tenzij wettelijk vereist.",
			intro: () => "Wij delen gegevens met de volgende diensten van derden:",
			headers: () => [
				"Dienst",
				"Doel",
				"Privacybeleid"
			],
			linkText: () => "Bekijken"
		},
		userRights: {
			heading: () => "Uw rechten",
			intro: () => "U beschikt over de volgende rechten met betrekking tot uw persoonsgegevens:",
			labels: {
				access: () => "Recht op inzage in uw persoonsgegevens",
				rectification: () => "Recht op rectificatie van onjuiste gegevens",
				erasure: () => "Recht op wissing van uw gegevens",
				portability: () => "Recht op overdraagbaarheid van uw gegevens",
				restriction: () => "Recht op beperking van de verwerking",
				objection: () => "Recht van bezwaar tegen de verwerking",
				opt_out_sale: () => "Recht om bezwaar te maken tegen de verkoop van uw persoonlijke informatie",
				non_discrimination: () => "Recht op niet-discriminerende behandeling bij de uitoefening van uw rechten"
			}
		},
		dpo: {
			present: { trailing: () => ". U kunt voor alle vragen over dit beleid of over de wijze waarop wij uw persoonsgegevens verwerken rechtstreeks contact opnemen met onze Functionaris voor gegevensbescherming." },
			absentRequiredFalse: ({ reason }) => `Wij hebben geen Functionaris voor gegevensbescherming aangewezen. Onze verwerkingsactiviteiten bereiken niet de drempels van artikel 37, lid 1, AVG die een dergelijke aanwijzing zouden vereisen.${reason}`,
			absentFallback: () => "Wij hebben geen Functionaris voor gegevensbescherming aangewezen. Onze verwerkingsactiviteiten bereiken niet de drempels van artikel 37, lid 1, AVG die een dergelijke aanwijzing zouden vereisen. Voor vragen over dit beleid of over de wijze waarop wij uw persoonsgegevens verwerken, gebruikt u de bovenstaande contactgegevens."
		},
		euRepresentative: { body: ({ address, email }) => ({
			prefix: "Onze vertegenwoordiger in de Europese Unie in de zin van artikel 27 AVG is ",
			suffix: `, ${address}, ${email}.`
		}) },
		gdprSupplement: {
			heading: () => "Aanvullende AVG-informatie",
			scope: () => "Dit gedeelte is van toepassing op personen in de Europese Economische Ruimte (EER) op grond van de Algemene Verordening Gegevensbescherming (AVG).",
			dataControllerLabel: () => "Verwerkingsverantwoordelijke: ",
			complaintBody: {
				prefix: () => "U heeft het recht een klacht in te dienen bij de toezichthoudende autoriteit voor gegevensbescherming van het land waarin u woont, waar u werkt of waar de vermeende inbreuk heeft plaatsgevonden. Een lijst met toezichthoudende autoriteiten in de EER vindt u op ",
				linkText: () => "edpb.europa.eu/about-edpb/about-edpb/members_en",
				suffix: () => "."
			},
			transferBody: {
				prefix: () => "Wanneer wij uw persoonsgegevens doorgeven buiten de EER, beroepen wij ons op een of meer van de waarborgen voorzien in hoofdstuk V AVG: (a) doorgiften naar landen waarvoor de Europese Commissie een adequaatheidsbesluit heeft genomen (de actuele lijst is gepubliceerd op ",
				adequacyLinkText: () => "commission.europa.eu/.../adequacy-decisions_en",
				middle: () => "); (b) standaardcontractbepalingen (SCC's) vastgesteld door de Europese Commissie op grond van artikel 46, lid 2, onder c); en (c) bindende bedrijfsvoorschriften (BCR's) goedgekeurd op grond van artikel 47, voor zover van toepassing. Voor aanvullende informatie over de specifieke waarborgen die op een bepaalde doorgifte van toepassing zijn, kunt u contact met ons opnemen via ",
				email: ({ contactEmail }) => `${contactEmail}.`
			}
		},
		ukGdprSupplement: {
			heading: () => "Privacyrechten in het Verenigd Koninkrijk (UK-GDPR)",
			scope: () => "Dit gedeelte is van toepassing op personen in het Verenigd Koninkrijk op grond van de UK General Data Protection Regulation (UK-GDPR), zoals aangepast door de Data Protection Act 2018.",
			dataControllerLabel: () => "Verwerkingsverantwoordelijke: ",
			ico: {
				prefix: () => "De toezichthoudende autoriteit voor gegevensbescherming in het Verenigd Koninkrijk is het ",
				label: () => "Information Commissioner's Office (ICO)",
				suffix: () => ". Als u van mening bent dat wij uw gegevens niet hebben behandeld in overeenstemming met het Britse gegevensbeschermingsrecht, heeft u het recht een klacht in te dienen bij het ICO via ",
				linkText: () => "ico.org.uk/make-a-complaint",
				suffix2: () => "."
			},
			transferBody: () => "Indien wij uw persoonsgegevens doorgeven buiten het Verenigd Koninkrijk, zorgen wij ervoor dat passende waarborgen aanwezig zijn in overeenstemming met de UK-GDPR, waaronder de UK International Data Transfer Agreement of het UK-addendum bij de standaardcontractbepalingen van de EU, voor zover van toepassing."
		},
		ccpaSupplement: {
			heading: () => "Privacyrechten in Californië (CCPA)",
			intro: () => "Als u inwoner van Californië bent, beschikt u over de volgende aanvullende rechten:",
			rights: {
				know: () => "Recht op informatie — U kunt verzoeken om openbaarmaking van de persoonlijke informatie die wij over u verzamelen, gebruiken en delen.",
				delete: () => "Recht op verwijdering — U kunt verzoeken om verwijdering van de persoonlijke informatie die wij over u hebben verzameld.",
				optOut: () => "Recht om bezwaar te maken tegen verkoop — U kunt zich verzetten tegen de verkoop van uw persoonlijke informatie.",
				nonDiscrimination: () => "Recht op niet-discriminatie — Wij zullen u niet discrimineren wegens de uitoefening van uw CCPA-rechten."
			},
			submitting: {
				label: () => "Indienen van verzoeken.",
				body: () => " Om een van deze rechten uit te oefenen, neemt u contact met ons op via een van de hieronder vermelde methoden. Wij zullen reageren binnen de termijnen voorgeschreven door CCPA §1798.130."
			}
		},
		contact: {
			heading: () => "Contact",
			intro: () => "Neem contact met ons op:"
		},
		provisionBasisLabels: {
			statutory: () => "Wettelijk verplicht",
			contractual: () => "Contractueel verplicht",
			"contract-prerequisite": () => "Voorwaarde voor het sluiten van een overeenkomst",
			voluntary: () => "Vrijwillig"
		},
		cookieCategoryLabels: {
			essential: () => "Essentiële cookies — vereist voor het functioneren van de dienst",
			analytics: () => "Analytische cookies — helpen ons te begrijpen hoe de dienst wordt gebruikt",
			functional: () => "Functionele cookies — onthouden uw voorkeuren en instellingen",
			marketing: () => "Marketingcookies — gebruikt om relevante advertenties weer te geven"
		},
		cookieCategoryFallback: ({ key }) => `${key}-cookies`
	},
	cookie: {
		introduction: {
			heading: () => "Cookiebeleid",
			body: ({ companyName, effectiveDate, versionSuffix }) => `Dit cookiebeleid legt uit hoe ${companyName} ('wij', 'ons' of 'onze') cookies en vergelijkbare trackingtechnologieën gebruikt op onze diensten. Ingangsdatum: ${effectiveDate}.${versionSuffix}`
		},
		whatAreCookies: {
			heading: () => "Wat zijn cookies?",
			body1: () => "Cookies zijn kleine tekstbestanden die op uw apparaat worden geplaatst door websites die u bezoekt. Ze worden veel gebruikt om websites efficiënter te laten werken en om informatie te leveren aan de eigenaren van de website.",
			body2: () => "Cookies kunnen 'sessiecookies' zijn (worden verwijderd bij het sluiten van uw browser) of 'permanente cookies' (blijven op uw apparaat totdat ze verlopen of u ze verwijdert)."
		},
		types: {
			heading: () => "Soorten cookies die wij gebruiken",
			empty: () => "Wij gebruiken op dit moment geen cookies.",
			headers: () => ["Type", "Omschrijving"],
			labels: {
				essential: {
					label: () => "Essentiële cookies",
					description: () => "Vereist voor het basisfunctioneren van onze diensten. Deze kunnen niet worden uitgeschakeld."
				},
				analytics: {
					label: () => "Analytische cookies",
					description: () => "Helpen ons te begrijpen hoe bezoekers met onze diensten omgaan zodat wij ze kunnen verbeteren."
				},
				functional: {
					label: () => "Functionele cookies",
					description: () => "Maken uitgebreide functionaliteit en personalisatie mogelijk, zoals het onthouden van uw voorkeuren."
				},
				marketing: {
					label: () => "Marketingcookies",
					description: () => "Gebruikt om advertenties te tonen die relevanter zijn voor u en uw interesses."
				}
			},
			fallback: ({ key }) => ({
				label: `${key.charAt(0).toUpperCase()}${key.slice(1)}-cookies`,
				description: ""
			})
		},
		trackingTechnologies: {
			heading: () => "Andere trackingtechnologieën",
			intro: () => "Naast cookies kunnen wij de volgende trackingtechnologieën gebruiken:"
		},
		thirdParties: {
			heading: () => "Cookies van derden",
			intro: () => "De volgende derden kunnen via onze diensten cookies plaatsen:",
			headers: () => [
				"Dienst",
				"Doel",
				"Privacybeleid"
			],
			linkText: () => "Bekijken"
		},
		consent: {
			heading: () => "Uw toestemming",
			banner: () => "Wij tonen bij uw eerste bezoek aan onze diensten een banner voor cookietoestemming.",
			panel: () => "U kunt uw cookievoorkeuren op elk gewenst moment beheren via ons voorkeurenpaneel.",
			withdraw: () => "U kunt uw toestemming op elk moment intrekken; dit doet echter geen afbreuk aan de rechtmatigheid van de op toestemming gebaseerde verwerking die heeft plaatsgevonden vóór de intrekking."
		},
		managing: {
			heading: () => "Cookies beheren",
			intro: () => "De meeste webbrowsers stellen u in staat cookies te beheren via hun instellingen. U kunt:",
			items: {
				delete: () => "Reeds op uw apparaat opgeslagen cookies verwijderen",
				block: () => "Het plaatsen van cookies op uw apparaat blokkeren",
				notify: () => "Uw browser zo instellen dat u een melding krijgt wanneer een cookie wordt geplaatst"
			},
			footer: () => "Houd er rekening mee dat het beperken van cookies de functionaliteit van onze diensten kan beïnvloeden. Raadpleeg de helpdocumentatie van uw browser voor instructies over het beheren van cookies."
		},
		jurisdictionEuUk: {
			heading: {
				euAndUk: () => "Gebruikers in de Europese Unie en het Verenigd Koninkrijk (AVG / UK-GDPR)",
				eu: () => "Gebruikers in de Europese Unie (AVG)",
				uk: () => "Gebruikers in het Verenigd Koninkrijk (UK-GDPR)"
			},
			body: ({ region }) => `Als u zich bevindt in ${region}, beroepen wij ons op uw toestemming als rechtsgrond voor het plaatsen van niet-essentiële cookies. U heeft te allen tijde het recht uw toestemming in te trekken.`,
			region: {
				euAndUk: () => "de Europese Economische Ruimte of het Verenigd Koninkrijk",
				eu: () => "de Europese Economische Ruimte",
				uk: () => "het Verenigd Koninkrijk"
			},
			essentialBody: () => "Essentiële cookies worden geplaatst op grond van ons gerechtvaardigd belang om u een functionerende dienst te bieden."
		},
		contact: {
			heading: () => "Contact",
			intro: () => "Als u vragen heeft over dit cookiebeleid, neem dan contact met ons op:"
		}
	}
};
//#endregion
//#region src/i18n/locales.ts
const LOCALES = [
	"en",
	"fr",
	"de",
	"nl",
	"es"
];
const dictionaries = {
	en,
	fr,
	de,
	nl,
	es
};
function isLocale(value) {
	return typeof value === "string" && LOCALES.includes(value);
}
//#endregion
//#region src/i18n/format.ts
const LOCALE_TAG = {
	en: "en-US",
	fr: "fr-FR",
	de: "de-DE",
	nl: "nl-NL",
	es: "es-ES"
};
function formatDate(date, locale) {
	const [y, m, d] = date.split("-").map(Number);
	const utc = new Date(Date.UTC(y, m - 1, d));
	return new Intl.DateTimeFormat(LOCALE_TAG[locale], {
		dateStyle: "long",
		timeZone: "UTC"
	}).format(utc);
}
//#endregion
//#region src/i18n/index.ts
function createT(locale) {
	return dictionaries[locale] ?? dictionaries.en;
}
//#endregion
//#region src/documents/helpers.ts
const heading = (value, levelOrContext, context) => {
	const level = typeof levelOrContext === "number" ? levelOrContext : void 0;
	const ctx = typeof levelOrContext === "object" ? levelOrContext : context;
	return {
		type: "heading",
		...level !== void 0 && { level },
		value,
		...ctx && { context: ctx }
	};
};
const text = (value, context) => ({
	type: "text",
	value,
	...context && { context }
});
const bold = (value, context) => ({
	type: "bold",
	value,
	...context && { context }
});
const italic = (value, context) => ({
	type: "italic",
	value,
	...context && { context }
});
const link = (href, value, context) => ({
	type: "link",
	href,
	value,
	...context && { context }
});
const p = (children, context) => ({
	type: "paragraph",
	children: children.map((c) => typeof c === "string" ? text(c) : c),
	...context && { context }
});
const li = (children, context) => ({
	type: "listItem",
	children: children.map((c) => typeof c === "string" ? text(c) : c),
	...context && { context }
});
const ul = (items, context) => ({
	type: "list",
	items,
	...context && { context }
});
const ol = (items, context) => ({
	type: "list",
	ordered: true,
	items,
	...context && { context }
});
const cell = (children, context) => ({
	type: "tableCell",
	children: children.map((c) => typeof c === "string" ? text(c) : c),
	...context && { context }
});
const row = (cells, context) => ({
	type: "tableRow",
	cells,
	...context && { context }
});
const table = (headerLabels, rows, context) => ({
	type: "table",
	header: row(headerLabels.map((l) => cell([l]))),
	rows,
	...context && { context }
});
const section = (id, content, context) => ({
	type: "section",
	id,
	content,
	...context && { context }
});
//#endregion
//#region src/documents/cookie.ts
function versionSuffix$1(config, t) {
	return config.version ? t.shared.versionSuffix({ version: config.version }) : "";
}
function buildIntroduction$1(config, t) {
	return section("cookie-introduction", [heading(t.cookie.introduction.heading()), p([t.cookie.introduction.body({
		companyName: config.company.name,
		effectiveDate: formatDate(config.effectiveDate, config.locale),
		versionSuffix: versionSuffix$1(config, t)
	})])]);
}
function buildWhatAreCookies(t) {
	return section("cookie-what-are-cookies", [
		heading(t.cookie.whatAreCookies.heading()),
		p([t.cookie.whatAreCookies.body1()]),
		p([t.cookie.whatAreCookies.body2()])
	]);
}
function cookieTypeMeta(key, t) {
	const entry = t.cookie.types.labels[key];
	if (entry) return {
		label: entry.label(),
		description: entry.description()
	};
	return t.cookie.types.fallback({ key });
}
function buildTypes(config, t) {
	const types = [];
	for (const [key, enabled] of Object.entries(config.cookies.used)) {
		if (!enabled) continue;
		types.push(cookieTypeMeta(key, t));
	}
	if (types.length === 0) return section("cookie-types", [heading(t.cookie.types.heading()), p([t.cookie.types.empty()])]);
	const rows = types.map((entry) => row([cell([bold(entry.label)]), cell([entry.description])]));
	return section("cookie-types", [heading(t.cookie.types.heading()), table(t.cookie.types.headers(), rows)]);
}
function buildTrackingTechnologies(config, t) {
	if (!config.trackingTechnologies || config.trackingTechnologies.length === 0) return null;
	return section("cookie-tracking-technologies", [
		heading(t.cookie.trackingTechnologies.heading()),
		p([t.cookie.trackingTechnologies.intro()]),
		ul(config.trackingTechnologies.map((tt) => li([tt])))
	]);
}
function buildThirdParties$1(config, t) {
	if (!config.thirdParties || config.thirdParties.length === 0) return null;
	const rows = config.thirdParties.map((tp) => row([
		cell([bold(tp.name)]),
		cell([tp.purpose]),
		cell(tp.policyUrl ? [link(tp.policyUrl, t.cookie.thirdParties.linkText())] : [""])
	]));
	return section("cookie-third-parties", [
		heading(t.cookie.thirdParties.heading()),
		p([t.cookie.thirdParties.intro()]),
		table(t.cookie.thirdParties.headers(), rows)
	]);
}
function buildConsent(config, t) {
	if (!config.consentMechanism) return null;
	const { hasBanner, hasPreferencePanel, canWithdraw } = config.consentMechanism;
	const items = [];
	if (hasBanner) items.push(t.cookie.consent.banner());
	if (hasPreferencePanel) items.push(t.cookie.consent.panel());
	if (canWithdraw) items.push(t.cookie.consent.withdraw());
	if (items.length === 0) return null;
	return section("cookie-consent", [heading(t.cookie.consent.heading()), ul(items.map((i) => li([i])))]);
}
function buildManaging(t) {
	return section("cookie-managing", [
		heading(t.cookie.managing.heading()),
		p([t.cookie.managing.intro()]),
		ul([
			li([t.cookie.managing.items.delete()]),
			li([t.cookie.managing.items.block()]),
			li([t.cookie.managing.items.notify()])
		]),
		p([t.cookie.managing.footer()])
	]);
}
function buildJurisdictionEuUk(config, t) {
	const hasEu = config.jurisdictions.includes("eu");
	const hasUk = config.jurisdictions.includes("uk");
	if (!hasEu && !hasUk) return null;
	const branch = hasEu && hasUk ? "euAndUk" : hasEu ? "eu" : "uk";
	const reason = hasUk ? "Required under the UK-GDPR and PECR" : "Required under ePrivacy Directive and GDPR";
	return section("cookie-jurisdiction-eu-uk", [
		heading(t.cookie.jurisdictionEuUk.heading[branch](), { reason }),
		p([t.cookie.jurisdictionEuUk.body({ region: t.cookie.jurisdictionEuUk.region[branch]() })]),
		p([t.cookie.jurisdictionEuUk.essentialBody()])
	]);
}
function buildContact$1(config, t) {
	const items = [
		li([bold(`${t.shared.contactLabels.legalName()} `), config.company.legalName]),
		li([bold(`${t.shared.contactLabels.address()} `), config.company.address]),
		li([bold(`${t.shared.contactLabels.email()} `), config.company.contact.email])
	];
	if (config.company.contact.phone) items.push(li([bold(`${t.shared.contactLabels.phone()} `), config.company.contact.phone]));
	return section("cookie-contact", [
		heading(t.cookie.contact.heading()),
		p([t.cookie.contact.intro()]),
		ul(items)
	]);
}
const SECTION_BUILDERS$1 = [
	buildIntroduction$1,
	(_, t) => buildWhatAreCookies(t),
	buildTypes,
	buildTrackingTechnologies,
	buildThirdParties$1,
	buildConsent,
	(_, t) => buildManaging(t),
	buildJurisdictionEuUk,
	buildContact$1
];
function compileCookieDocument(config, t) {
	return SECTION_BUILDERS$1.map((builder) => builder(config, t)).filter((s) => s !== null);
}
//#endregion
//#region src/documents/privacy.ts
function versionSuffix(config, t) {
	return config.version ? t.shared.versionSuffix({ version: config.version }) : "";
}
function buildIntroduction(config, t) {
	return section("introduction", [
		heading(t.privacy.introduction.heading()),
		p([t.privacy.introduction.body({
			companyName: config.company.name,
			effectiveDate: formatDate(config.effectiveDate, config.locale),
			versionSuffix: versionSuffix(config, t)
		})]),
		p([t.privacy.introduction.contactLine({ contactEmail: config.company.contact.email })])
	]);
}
function buildChildrenPrivacy(config, t) {
	if (!config.children) return null;
	const { underAge, noticeUrl } = config.children;
	return section("children-privacy", [
		heading(t.privacy.childrenPrivacy.heading(), { reason: "Required by COPPA" }),
		p([t.privacy.childrenPrivacy.body({ underAge })]),
		...noticeUrl ? [p([
			t.privacy.childrenPrivacy.noticeLinkPrefix(),
			link(noticeUrl, t.privacy.childrenPrivacy.noticeLinkText()),
			"."
		])] : []
	]);
}
function buildDataCollected(config, t) {
	const { collected, context } = config.data;
	const includeLegalBasis = config.jurisdictions.includes("eu") || config.jurisdictions.includes("uk");
	const rows = Object.entries(collected).map(([category, fields]) => {
		const entry = context[category];
		if (!entry?.purpose) throw new Error(`OpenPolicy: data.collected["${category}"] has no matching entry in data.context. Every collected category must declare its processing purpose (GDPR Art. 13(1)(c)).`);
		const cells = [
			cell([bold(category)]),
			cell([fields.join(", ")]),
			cell([entry.purpose])
		];
		if (includeLegalBasis) {
			const label = t.shared.legalBasisLabels[entry.lawfulBasis]();
			cells.push(cell([label]));
		}
		return row(cells);
	});
	const headerLabels = includeLegalBasis ? t.privacy.dataCollected.headers.withGdpr() : t.privacy.dataCollected.headers.withoutGdpr();
	const intro = includeLegalBasis ? t.privacy.dataCollected.intro.withGdpr() : t.privacy.dataCollected.intro.withoutGdpr();
	const reason = includeLegalBasis ? "Required by GDPR Article 13(1)(c) and Article 6" : "Required by GDPR Article 13(1)(c)";
	return section("data-collected", [
		heading(t.privacy.dataCollected.heading(), { reason }),
		p([intro]),
		table(headerLabels, rows)
	]);
}
function usesConsent(config) {
	if (Object.values(config.data.context).some((e) => e.lawfulBasis === "consent")) return true;
	if (Object.values(config.cookies.context).some((e) => e.lawfulBasis === "consent")) return true;
	return false;
}
function buildConsentWithdrawal(config, t) {
	if (!config.jurisdictions.includes("eu") && !config.jurisdictions.includes("uk")) return null;
	if (!usesConsent(config)) return null;
	return section("consent-withdrawal", [heading(t.privacy.consentWithdrawal.heading(), { reason: "Required by GDPR Article 7(3) and Article 13(2)(c)" }), p([t.privacy.consentWithdrawal.body({ contactEmail: config.company.contact.email })])]);
}
function buildAutomatedDecisionMaking(config, t) {
	if (!config.jurisdictions.includes("eu") && !config.jurisdictions.includes("uk")) return null;
	const decisions = config.automatedDecisionMaking;
	if (decisions === void 0) return null;
	const content = [heading(t.privacy.automatedDecisionMaking.heading(), { reason: "Required by GDPR and UK-GDPR Article 13(2)(f) and Article 22" })];
	if (decisions.length === 0) {
		content.push(p([t.privacy.automatedDecisionMaking.empty()]));
		return section("automated-decision-making", content);
	}
	content.push(p([t.privacy.automatedDecisionMaking.intro()]));
	for (const d of decisions) content.push(p([
		bold(d.name),
		" — ",
		d.logic,
		" ",
		bold(t.privacy.automatedDecisionMaking.significanceLabel()),
		" ",
		d.significance
	]));
	content.push(p([bold(t.privacy.automatedDecisionMaking.humanReview.label()), t.privacy.automatedDecisionMaking.humanReview.body({ contactEmail: config.company.contact.email })]));
	return section("automated-decision-making", content);
}
function buildDataRetention(config, t) {
	const rows = Object.entries(config.data.context).map(([category, entry]) => row([cell([bold(category)]), cell([entry.retention])]));
	return section("data-retention", [
		heading(t.privacy.dataRetention.heading()),
		p([t.privacy.dataRetention.intro()]),
		table(t.privacy.dataRetention.headers(), rows)
	]);
}
function buildProvisionRequirement(config, t) {
	if (!config.jurisdictions.includes("eu") && !config.jurisdictions.includes("uk")) return null;
	const entries = Object.entries(config.data.context);
	if (entries.length === 0) return null;
	const rows = entries.map(([category, entry]) => {
		const requirement = entry.provision;
		const label = t.privacy.provisionBasisLabels[requirement.basis]();
		return row([
			cell([bold(category)]),
			cell([label]),
			cell([requirement.consequences])
		]);
	});
	return section("provision-requirement", [
		heading(t.privacy.provisionRequirement.heading(), { reason: "Required by GDPR and UK-GDPR Article 13(2)(e)" }),
		p([t.privacy.provisionRequirement.body()]),
		table(t.privacy.provisionRequirement.headers(), rows)
	]);
}
function cookieCategoryLabel(key, t) {
	const entry = t.privacy.cookieCategoryLabels[key];
	return entry ? entry() : t.privacy.cookieCategoryFallback({ key });
}
function buildCookies(config, t) {
	const rows = [];
	for (const [key, enabled] of Object.entries(config.cookies.used)) {
		if (!enabled) continue;
		const label = cookieCategoryLabel(key, t);
		const basis = config.cookies.context[key]?.lawfulBasis;
		rows.push(row([cell([label]), cell([basis ? t.shared.legalBasisLabels[basis]() : ""])]));
	}
	if (rows.length === 0) return section("cookies", [heading(t.privacy.cookies.heading()), p([t.privacy.cookies.empty()])]);
	return section("cookies", [
		heading(t.privacy.cookies.heading()),
		p([t.privacy.cookies.intro()]),
		table(t.privacy.cookies.headers(), rows)
	]);
}
function buildThirdParties(config, t) {
	if (config.thirdParties.length === 0) return section("third-parties", [heading(t.privacy.thirdParties.heading()), p([t.privacy.thirdParties.empty()])]);
	const rows = config.thirdParties.map((tp) => row([
		cell([bold(tp.name)]),
		cell([tp.purpose]),
		cell(tp.policyUrl ? [link(tp.policyUrl, t.privacy.thirdParties.linkText())] : [""])
	]));
	return section("third-parties", [
		heading(t.privacy.thirdParties.heading()),
		p([t.privacy.thirdParties.intro()]),
		table(t.privacy.thirdParties.headers(), rows)
	]);
}
function buildUserRights(config, t) {
	if (config.userRights.length === 0) return null;
	const items = config.userRights.map((right) => li([t.privacy.userRights.labels[right]()]));
	return section("user-rights", [
		heading(t.privacy.userRights.heading()),
		p([t.privacy.userRights.intro()]),
		ul(items)
	]);
}
function dpoParagraph(config, t) {
	const { dpo } = config.company;
	if (dpo && "email" in dpo) {
		const parts = [bold(t.shared.contactLabels.dpo()), " "];
		if (dpo.name) parts.push(dpo.name, ", ");
		parts.push(dpo.email);
		if (dpo.phone) parts.push(", ", dpo.phone);
		if (dpo.address) parts.push(", ", dpo.address);
		parts.push(t.privacy.dpo.present.trailing());
		return p(parts);
	}
	if (dpo && "required" in dpo && dpo.required === false) {
		const reason = dpo.reason ? ` ${dpo.reason}` : "";
		return p([t.privacy.dpo.absentRequiredFalse({ reason })]);
	}
	return p([t.privacy.dpo.absentFallback()]);
}
function euRepresentativeParagraph(config, t) {
	const rep = config.company.euRepresentative;
	if (!rep) return null;
	const { prefix, suffix } = t.privacy.euRepresentative.body({
		name: rep.name,
		address: rep.address,
		email: rep.email
	});
	return p([
		prefix,
		bold(rep.name),
		suffix
	]);
}
function buildGdprSupplement(config, t) {
	if (!config.jurisdictions.includes("eu")) return null;
	const content = [
		heading(t.privacy.gdprSupplement.heading(), { reason: "Required by GDPR Article 13" }),
		p([t.privacy.gdprSupplement.scope()]),
		p([
			t.privacy.gdprSupplement.dataControllerLabel(),
			bold(config.company.legalName),
			`, ${config.company.address}`
		]),
		dpoParagraph(config, t),
		p([
			t.privacy.gdprSupplement.complaintBody.prefix(),
			link("https://edpb.europa.eu/about-edpb/about-edpb/members_en", t.privacy.gdprSupplement.complaintBody.linkText()),
			t.privacy.gdprSupplement.complaintBody.suffix()
		]),
		p([
			t.privacy.gdprSupplement.transferBody.prefix(),
			link("https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en", t.privacy.gdprSupplement.transferBody.adequacyLinkText()),
			t.privacy.gdprSupplement.transferBody.middle(),
			t.privacy.gdprSupplement.transferBody.email({ contactEmail: config.company.contact.email })
		])
	];
	const rep = euRepresentativeParagraph(config, t);
	if (rep) content.push(rep);
	return section("gdpr-supplement", content);
}
function buildUkGdprSupplement(config, t) {
	if (!config.jurisdictions.includes("uk")) return null;
	return section("uk-gdpr-supplement", [
		heading(t.privacy.ukGdprSupplement.heading(), { reason: "Required by the UK-GDPR and Data Protection Act 2018" }),
		p([t.privacy.ukGdprSupplement.scope()]),
		p([
			t.privacy.ukGdprSupplement.dataControllerLabel(),
			bold(config.company.legalName),
			`, ${config.company.address}`
		]),
		dpoParagraph(config, t),
		p([
			t.privacy.ukGdprSupplement.ico.prefix(),
			bold(t.privacy.ukGdprSupplement.ico.label()),
			t.privacy.ukGdprSupplement.ico.suffix(),
			link("https://ico.org.uk/make-a-complaint/", t.privacy.ukGdprSupplement.ico.linkText()),
			t.privacy.ukGdprSupplement.ico.suffix2()
		]),
		p([t.privacy.ukGdprSupplement.transferBody()])
	]);
}
function buildCcpaSupplement(config, t) {
	if (!config.jurisdictions.includes("us-ca")) return null;
	const { email, phone } = config.company.contact;
	const submissionMethods = [li([
		bold(t.shared.contactLabels.email()),
		" ",
		email
	])];
	if (phone) submissionMethods.push(li([
		bold(t.shared.contactLabels.phone()),
		" ",
		phone
	]));
	return section("ccpa-supplement", [
		heading(t.privacy.ccpaSupplement.heading(), { reason: "Required by CCPA" }),
		p([t.privacy.ccpaSupplement.intro()]),
		ul([
			li([t.privacy.ccpaSupplement.rights.know()]),
			li([t.privacy.ccpaSupplement.rights.delete()]),
			li([t.privacy.ccpaSupplement.rights.optOut()]),
			li([t.privacy.ccpaSupplement.rights.nonDiscrimination()])
		]),
		p([bold(t.privacy.ccpaSupplement.submitting.label()), t.privacy.ccpaSupplement.submitting.body()]),
		ul(submissionMethods)
	]);
}
function buildContact(config, t) {
	const items = [
		li([
			bold(t.shared.contactLabels.legalName()),
			" ",
			config.company.legalName
		]),
		li([
			bold(t.shared.contactLabels.address()),
			" ",
			config.company.address
		]),
		li([
			bold(t.shared.contactLabels.email()),
			" ",
			config.company.contact.email
		])
	];
	if (config.company.contact.phone) items.push(li([
		bold(t.shared.contactLabels.phone()),
		" ",
		config.company.contact.phone
	]));
	const { dpo } = config.company;
	if (dpo && "email" in dpo) {
		const dpoParts = [bold(t.shared.contactLabels.dpo()), " "];
		if (dpo.name) dpoParts.push(dpo.name, ", ");
		dpoParts.push(dpo.email);
		if (dpo.phone) dpoParts.push(", ", dpo.phone);
		if (dpo.address) dpoParts.push(", ", dpo.address);
		items.push(li(dpoParts));
	}
	return section("contact", [
		heading(t.privacy.contact.heading()),
		p([t.privacy.contact.intro()]),
		ul(items)
	]);
}
const SECTION_BUILDERS = [
	buildIntroduction,
	buildChildrenPrivacy,
	buildDataCollected,
	buildConsentWithdrawal,
	buildAutomatedDecisionMaking,
	buildDataRetention,
	buildProvisionRequirement,
	buildCookies,
	buildThirdParties,
	buildUserRights,
	buildGdprSupplement,
	buildUkGdprSupplement,
	buildCcpaSupplement,
	buildContact
];
function compilePrivacyDocument(config, t) {
	if (Object.keys(config.data.collected).length === 0) throw new Error("OpenPolicy: cannot compile a privacy policy with no data collected. Populate `data.collected` in your config, or instrument `collecting()` calls and use the `openPolicy()` Vite plugin.");
	return SECTION_BUILDERS.map((builder) => builder(config, t)).filter((s) => s !== null);
}
//#endregion
//#region src/documents/index.ts
function compile(input) {
	const t = createT(input.locale);
	if (input.type === "privacy") {
		const { type: _, ...config } = input;
		return {
			type: "document",
			policyType: "privacy",
			sections: compilePrivacyDocument(config, t)
		};
	}
	const { type: _, ...config } = input;
	return {
		type: "document",
		policyType: "cookie",
		sections: compileCookieDocument(config, t)
	};
}
//#endregion
//#region src/jurisdictions.ts
const JURISDICTIONS = [
	"eu",
	"uk",
	"us-ca",
	"us-va",
	"us-co",
	"br",
	"ca",
	"au",
	"jp",
	"sg"
];
function isJurisdiction(value) {
	return JURISDICTIONS.includes(value);
}
//#endregion
//#region src/types.ts
function isOpenPolicyConfig(value) {
	if (value === null || typeof value !== "object") return false;
	const obj = value;
	return "company" in obj && "effectiveDate" in obj && !("type" in obj);
}
//#endregion
//#region src/provision.ts
/**
* Helpers that build a {@link ProvisionRequirement} for `data.context[category].provision`.
* Each call carries the consequences of failing to provide the data, as
* required by GDPR Article 13(2)(e).
*/
const Statutory = (consequences) => ({
	basis: "statutory",
	consequences
});
const Contractual = (consequences) => ({
	basis: "contractual",
	consequences
});
const ContractPrerequisite = (consequences) => ({
	basis: "contract-prerequisite",
	consequences
});
const Voluntary = (consequences) => ({
	basis: "voluntary",
	consequences
});
//#endregion
//#region src/policy-version.ts
function stableSerialize(value) {
	if (value === null || typeof value !== "object") return JSON.stringify(value);
	if (Array.isArray(value)) return `[${value.map(stableSerialize).join(",")}]`;
	return `{${Object.entries(value).filter(([, v]) => v !== void 0).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0).map(([k, v]) => `${JSON.stringify(k)}:${stableSerialize(v)}`).join(",")}}`;
}
function fnv1a32(str) {
	let hash = 2166136261;
	for (let i = 0; i < str.length; i++) {
		hash ^= str.charCodeAt(i);
		hash = Math.imul(hash, 16777619);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
}
const PRIVACY_HASH_FIELDS = [
	"company",
	"effectiveDate",
	"jurisdictions",
	"locale",
	"data",
	"children",
	"thirdParties",
	"automatedDecisionMaking",
	"cookies"
];
const COOKIE_HASH_FIELDS = [
	"company",
	"effectiveDate",
	"jurisdictions",
	"locale",
	"cookies",
	"thirdParties",
	"trackingTechnologies",
	"consentMechanism"
];
function hashSlice(config, fields) {
	const slice = {};
	for (const field of fields) {
		const value = config[field];
		if (value !== void 0) slice[field] = value;
	}
	return fnv1a32(stableSerialize(slice));
}
function hasAnyPrivacyField$2(config) {
	return config.data !== void 0 || config.children !== void 0;
}
function shouldHashPrivacy(config) {
	if (config.policies) return config.policies.includes("privacy");
	return hasAnyPrivacyField$2(config);
}
function shouldHashCookie(config) {
	if (config.policies) return config.policies.includes("cookie");
	return config.cookies !== void 0;
}
function computePrivacyVersion(config) {
	if (!shouldHashPrivacy(config)) return void 0;
	return hashSlice(config, PRIVACY_HASH_FIELDS);
}
function computeCookieVersion(config) {
	if (!shouldHashCookie(config)) return void 0;
	return hashSlice(config, COOKIE_HASH_FIELDS);
}
//#endregion
//#region src/user-rights.ts
const GDPR_RIGHTS = [
	"access",
	"rectification",
	"erasure",
	"portability",
	"restriction",
	"objection"
];
const RIGHTS_BY_JURISDICTION = {
	eu: GDPR_RIGHTS,
	uk: GDPR_RIGHTS,
	"us-ca": [
		"access",
		"erasure",
		"opt_out_sale",
		"non_discrimination"
	]
};
const CANONICAL_ORDER = [
	"access",
	"rectification",
	"erasure",
	"portability",
	"restriction",
	"objection",
	"opt_out_sale",
	"non_discrimination"
];
function deriveUserRights(jurisdictions) {
	const set = /* @__PURE__ */ new Set();
	for (const j of jurisdictions) for (const right of RIGHTS_BY_JURISDICTION[j] ?? []) set.add(right);
	return CANONICAL_ORDER.filter((right) => set.has(right));
}
//#endregion
//#region src/validate.ts
function validatePrivacyPolicy(config) {
	const issues = [];
	if (!config.effectiveDate) issues.push({
		code: "effective-date-required",
		level: "error",
		message: "effectiveDate is required"
	});
	if (!config.company.name) issues.push({
		code: "company-name-required",
		level: "error",
		message: "company.name is required"
	});
	if (!config.company.legalName) issues.push({
		code: "company-legal-name-required",
		level: "error",
		message: "company.legalName is required"
	});
	if (!config.company.address) issues.push({
		code: "company-address-required",
		level: "error",
		message: "company.address is required"
	});
	if (!config.company.contact?.email) issues.push({
		code: "company-contact-required",
		level: "error",
		message: "company.contact.email is required"
	});
	const { collected, context } = config.data;
	if (Object.keys(collected).length === 0) issues.push({
		code: "data-collected-required",
		level: "error",
		message: "data.collected must have at least one entry"
	});
	for (const category of Object.keys(collected)) {
		const entry = context[category];
		if (entry === void 0) {
			issues.push({
				code: "data-context-missing",
				level: "error",
				message: `data.context["${category}"] is missing — every collected category requires a context entry (purpose, lawful basis, retention, provision).`
			});
			continue;
		}
		if (entry.purpose === void 0) issues.push({
			code: "data-purpose-missing",
			level: "error",
			message: `data.context["${category}"].purpose is missing — every collected category requires a processing purpose (GDPR Art. 13(1)(c))`
		});
		else if (entry.purpose.trim().length === 0) issues.push({
			code: "data-purpose-empty",
			level: "error",
			message: `data.context["${category}"].purpose must be a non-empty string`
		});
	}
	for (const category of Object.keys(context)) if (!(category in collected)) issues.push({
		code: "data-context-orphan",
		level: "error",
		message: `data.context["${category}"] has no matching entry in data.collected — remove it or declare the collected fields`
	});
	if (config.jurisdictions.includes("eu") || config.jurisdictions.includes("uk")) {
		for (const category of Object.keys(collected)) if (!context[category]?.lawfulBasis) issues.push({
			code: "lawful-basis-incomplete",
			level: "error",
			message: `GDPR Article 13(1)(c): data.context["${category}"].lawfulBasis is missing — every collected category requires an Article 6 lawful basis.`
		});
		for (const category of Object.keys(collected)) {
			const pr = context[category]?.provision;
			if (!pr || !pr.basis) issues.push({
				code: "statutory-contractual-obligation",
				level: "error",
				message: `GDPR Article 13(2)(e): data.context["${category}"].provision is missing — disclose whether provision is statutory, contractual, a contract-prerequisite, or voluntary, and the consequences of failure to provide it.`
			});
			else if (typeof pr.consequences !== "string" || pr.consequences.trim().length === 0) issues.push({
				code: "statutory-contractual-obligation",
				level: "error",
				message: `GDPR Article 13(2)(e): data.context["${category}"].provision.consequences is empty — state the consequences of failure to provide this data.`
			});
		}
	}
	for (const category of Object.keys(collected)) {
		const period = context[category]?.retention;
		if (period === void 0 || period.trim().length === 0) issues.push({
			code: "retention-incomplete",
			level: "error",
			message: `data.context["${category}"].retention is missing — declare a retention period for every collected category.`
		});
	}
	if ((config.jurisdictions.includes("eu") || config.jurisdictions.includes("uk")) && config.automatedDecisionMaking === void 0) issues.push({
		code: "automated-decision-making",
		level: "warning",
		message: "GDPR Article 13(2)(f) requires disclosure of whether automated decision-making (including profiling under Article 22) is used. Set `automatedDecisionMaking: []` to declare none, or list each activity with its logic and significance."
	});
	if (config.children) {
		if (config.children.underAge <= 0) issues.push({
			code: "children-under-age-invalid",
			level: "error",
			message: "children.underAge must be a positive number"
		});
	}
	return issues;
}
//#endregion
//#region src/validate-config.ts
function validateOpenPolicyConfig(config) {
	const issues = [];
	if (!config.effectiveDate) issues.push({
		code: "effective-date-required",
		level: "error",
		message: "effectiveDate is required"
	});
	if (!config.company?.name) issues.push({
		code: "company-name-required",
		level: "error",
		message: "company.name is required"
	});
	if (!config.company?.legalName) issues.push({
		code: "company-legal-name-required",
		level: "error",
		message: "company.legalName is required"
	});
	if (!config.company?.address) issues.push({
		code: "company-address-required",
		level: "error",
		message: "company.address is required"
	});
	if (!config.company?.contact?.email) issues.push({
		code: "company-contact-required",
		level: "error",
		message: "company.contact.email is required"
	});
	if (!config.jurisdictions || config.jurisdictions.length === 0) issues.push({
		code: "jurisdictions-required",
		level: "error",
		message: "jurisdictions must have at least one entry"
	});
	else for (const code of config.jurisdictions) if (!isJurisdiction(code)) issues.push({
		code: "jurisdiction-unknown",
		level: "error",
		message: `Unknown jurisdiction "${code}" — valid codes: ${JURISDICTIONS.join(", ")}`
	});
	if (config.locale !== void 0 && !isLocale(config.locale)) issues.push({
		code: "locale-unknown",
		level: "error",
		message: `Unknown locale "${config.locale}" — valid codes: ${LOCALES.join(", ")}`
	});
	const wantPrivacy = shouldEmit("privacy", config);
	const wantCookie = shouldEmit("cookie", config);
	if (!wantPrivacy && !wantCookie) issues.push({
		code: "policy-empty",
		level: "error",
		message: "Config must produce at least one policy — provide data-handling fields (data, children) or cookies"
	});
	if (config.policies) for (const category of config.policies) {
		if (category === "privacy" && !hasAnyPrivacyField$1(config)) issues.push({
			code: "policy-privacy-empty",
			level: "error",
			message: "policies includes \"privacy\" but no data-handling fields are set — add data or children"
		});
		if (category === "cookie" && !config.cookies) issues.push({
			code: "policy-cookie-empty",
			level: "error",
			message: "policies includes \"cookie\" but cookies is not set"
		});
	}
	if (wantPrivacy && !config.data) issues.push({
		code: "data-missing",
		level: "warning",
		message: "data is not set — the privacy policy will render a placeholder section"
	});
	if (wantPrivacy && config.data) {
		const collectedKeys = Object.keys(config.data.collected);
		if (config.jurisdictions?.includes("eu") || config.jurisdictions?.includes("uk")) for (const category of collectedKeys) {
			if (!config.data.context?.[category]?.lawfulBasis) issues.push({
				code: "lawful-basis-incomplete",
				level: "error",
				message: `data.context["${category}"].lawfulBasis is missing — every collected category requires an Article 6 lawful basis (GDPR Art. 13(1)(c)).`
			});
			const pr = config.data.context?.[category]?.provision;
			if (!pr || !pr.basis) issues.push({
				code: "statutory-contractual-obligation",
				level: "error",
				message: `data.context["${category}"].provision is missing — GDPR Art. 13(2)(e) requires disclosure of whether provision is statutory, contractual, a contract-prerequisite, or voluntary, and the consequences of failure to provide it.`
			});
			else if (typeof pr.consequences !== "string" || pr.consequences.trim().length === 0) issues.push({
				code: "statutory-contractual-obligation",
				level: "error",
				message: `data.context["${category}"].provision.consequences is empty — GDPR Art. 13(2)(e) requires the consequences of failure to provide this data.`
			});
		}
		for (const category of collectedKeys) {
			const period = config.data.context?.[category]?.retention;
			if (period === void 0 || period.trim().length === 0) issues.push({
				code: "retention-incomplete",
				level: "error",
				message: `data.context["${category}"].retention is missing — declare a retention period for every collected category.`
			});
		}
	}
	if (config.cookies) {
		const used = config.cookies.used ?? {};
		for (const [key, enabled] of Object.entries(used)) {
			if (!enabled) continue;
			if (!config.cookies.context?.[key]?.lawfulBasis) issues.push({
				code: "cookie-lawful-basis-missing",
				level: "error",
				message: `cookies.context["${key}"].lawfulBasis is missing — every enabled cookie category requires an Article 6 lawful basis.`
			});
		}
	}
	const gdprScope = config.jurisdictions?.includes("eu") || config.jurisdictions?.includes("uk");
	if (wantPrivacy && gdprScope && config.company?.dpo === void 0) issues.push({
		code: "company-dpo-undeclared",
		level: "warning",
		message: "company.dpo is not set — GDPR Article 13(1)(b) requires Data Protection Officer contact details if one is appointed. Set company.dpo, or set company.dpo = { required: false } to declare that none is needed."
	});
	if (wantPrivacy && config.jurisdictions?.includes("us-ca") && !config.company?.contact?.phone) issues.push({
		code: "company-contact-phone-recommended",
		level: "warning",
		message: "company.contact.phone is not set — CCPA §1798.130(a)(1) requires businesses to provide two or more designated methods for consumers to submit requests, and (unless you operate exclusively online) one must be a toll-free phone number."
	});
	return issues;
}
function hasAnyPrivacyField$1(config) {
	return config.data !== void 0 || config.children !== void 0;
}
//#endregion
//#region src/validate-cookie.ts
function validateCookiePolicy(config) {
	const issues = [];
	if (!config.effectiveDate) issues.push({
		code: "effective-date-required",
		level: "error",
		message: "effectiveDate is required"
	});
	if (!config.company.name) issues.push({
		code: "company-name-required",
		level: "error",
		message: "company.name is required"
	});
	if (!config.company.legalName) issues.push({
		code: "company-legal-name-required",
		level: "error",
		message: "company.legalName is required"
	});
	if (!config.company.address) issues.push({
		code: "company-address-required",
		level: "error",
		message: "company.address is required"
	});
	if (!config.company.contact?.email) issues.push({
		code: "company-contact-required",
		level: "error",
		message: "company.contact.email is required"
	});
	const used = config.cookies.used;
	const enabledKeys = Object.entries(used).filter(([, enabled]) => enabled).map(([key]) => key);
	if (enabledKeys.length === 0) issues.push({
		code: "cookies-empty",
		level: "error",
		message: "At least one cookie type must be enabled (essential, analytics, functional, or marketing)"
	});
	for (const key of enabledKeys) if (!config.cookies.context?.[key]?.lawfulBasis) issues.push({
		code: "cookie-lawful-basis-missing",
		level: "error",
		message: `cookies.context["${key}"].lawfulBasis is missing — every enabled cookie category requires an Article 6 lawful basis.`
	});
	if (!config.consentMechanism) issues.push({
		code: "consent-mechanism-undeclared",
		level: "warning",
		message: "consentMechanism is not provided — consider describing how users can manage cookie consent"
	});
	if ((config.jurisdictions.includes("eu") || config.jurisdictions.includes("uk")) && config.consentMechanism && !config.consentMechanism.canWithdraw) issues.push({
		code: "consent-withdrawal-required",
		level: "warning",
		message: "GDPR and UK-GDPR require that users can withdraw cookie consent — consider setting consentMechanism.canWithdraw to true"
	});
	return issues;
}
//#endregion
//#region src/index.ts
const PRIVACY_FIELDS = ["data", "children"];
function hasAnyPrivacyField(config) {
	return PRIVACY_FIELDS.some((field) => config[field] !== void 0);
}
function hasCookieField(config) {
	return config.cookies !== void 0;
}
function shouldEmit(category, config) {
	if (config.policies) return config.policies.includes(category);
	return category === "privacy" ? hasAnyPrivacyField(config) : hasCookieField(config);
}
const EMPTY_DATA = {
	collected: {},
	context: {}
};
const EMPTY_COOKIES = {
	used: { essential: true },
	context: {}
};
function buildPrivacyInput(config) {
	if (!shouldEmit("privacy", config)) return null;
	return {
		type: "privacy",
		company: config.company,
		effectiveDate: config.effectiveDate,
		locale: config.locale ?? "en",
		jurisdictions: config.jurisdictions,
		data: config.data ?? EMPTY_DATA,
		cookies: config.cookies ?? EMPTY_COOKIES,
		thirdParties: config.thirdParties ?? [],
		userRights: deriveUserRights(config.jurisdictions),
		children: config.children,
		automatedDecisionMaking: config.automatedDecisionMaking,
		version: config.privacyVersion
	};
}
function buildCookieInput(config) {
	if (!shouldEmit("cookie", config)) return null;
	return {
		type: "cookie",
		company: config.company,
		effectiveDate: config.effectiveDate,
		locale: config.locale ?? "en",
		jurisdictions: config.jurisdictions,
		cookies: config.cookies ?? EMPTY_COOKIES,
		thirdParties: config.thirdParties ?? [],
		trackingTechnologies: config.trackingTechnologies,
		consentMechanism: config.consentMechanism,
		version: config.cookieVersion
	};
}
function expandOpenPolicyConfig(config) {
	const inputs = [];
	const privacy = buildPrivacyInput(config);
	if (privacy) inputs.push(privacy);
	const cookie = buildCookieInput(config);
	if (cookie) inputs.push(cookie);
	return inputs;
}
function compilePrivacyPolicy(config) {
	const input = buildPrivacyInput(config);
	return input ? compile(input) : null;
}
function compileCookiePolicy(config) {
	const input = buildCookieInput(config);
	return input ? compile(input) : null;
}
//#endregion
export { ContractPrerequisite, Contractual, JURISDICTIONS, Statutory, Voluntary, bold, cell, compile, compileCookiePolicy, compilePrivacyPolicy, computeCookieVersion, computePrivacyVersion, deriveUserRights, expandOpenPolicyConfig, heading, isJurisdiction, isOpenPolicyConfig, italic, li, link, ol, p, row, section, shouldEmit, table, text, ul, validateCookiePolicy, validateOpenPolicyConfig, validatePrivacyPolicy };

//# sourceMappingURL=index.js.map